import appConfig from '../../../config/app_config';

const EN = {
  EMAIL: 'Email',
  CONFIRM_EMAIL: 'Confirm Email',
  LOG_OUT: 'Log out',
  DOUBLEUSERGROUP_ERROR: 'Sorry, you can only set 1 partner group to a user.',
  DUPLICATEDPARTNERNAME_ERROR:
    'Sorry, the partner name already exists within our system, please change the name and continue.',

  // Capacity Info page
  CAPACITY_INFO: 'Capacity info',
  CAP_CAL_FOR: 'Capacity calendar for',
  CAP_SEL_EVENT: 'Please select an event to retrieve the calendar data',
  CAP_EVENT_CAP: 'Event capacity: ',
  CAP_FREE_EVENT_CAP: 'Free event capacity: ',
  CAP_FREE_BATCH_CAP: 'Free batch capacity: ',
  CAP_BOOKED_BATCH_CAP: 'Booked batch capacity: ',
  CAP_CUR_OCCUPANCY: 'Current occupancy: ',
  CAP_TOTAL_EVENT_CAP: 'Total event capacity: ',
  CAP_BATCH_TIME: 'Batch time: ',
  CAP_TOTAL_BATCH_CAP: 'Total batch capacity: ',

  CREATE_EVENT: 'New Event',
  CATEGORIES_NONE: 'No categories available',

  EVENT_GRAPH_ORDER_TYPE:
    'The selected event might have a Delivery and a Take away option, please select one (if possible) to visualize the graph:',
  EVENT_GRAPH_SELECT_ORDER_TYPE: 'Please select the order type',
  EVENT_GRAPH_DATE_PICKER:
    'Select a date to view the expected crowds based on the number of reservations that day',
  EVENT_GRAPH_DETAILS: 'Expected crowds',

  // reorder alerts
  SUCCESS_PROD: 'The following items have been added to your shoppingcart:',
  FAIL_PROD: 'The following items could not be added to your shoppingcart:',

  // payments status error
  EXPIRED: 'Expired',
  CANCELED: 'Cancelled',
  FAILED: 'Failed',

  STATUS_CONFIRMED: 'Confirmed',
  STATUS_PARTNER_CONFIRM: 'Waiting for confirmation',
  STATUS_REQUESTED_PAYMENT: 'Waiting for payment',
  STATUS_CANCELLED: 'Cancelled',

  COMM_MGR_05: 'No users were found matching the selected criteria!',
  DEFINE_AREA: 'Define area',

  PIN: 'Pin',
  WELCOME_MESSAGE_TITLE: 'Welcome',
  WELCOME_MESSAGE: `Welcome to your personal page. Here you’ll find everything you need to plan and personalize your visit to ${appConfig.dss.environmentName}. You can easily change your preferences at Settings. We wish you a lot of fun during your visit to  ${appConfig.dss.environmentName} `,

  EDIT: 'Edit',
  EDIT_MESSAGE: 'Edit message',

  MESSAGE_TITLE_1: 'What kind of a message do you want to send?',
  MESSAGE_TITLE_2:
    'You can choose for a single message or start an engagement campaign',
  MESSAGE_TITLE_3:
    'To send a message I need to know who you want to send it to.',
  MESSAGE_TITLE_4:
    'What do you want to be send and when it should be delivered to them?',
  MESSAGE_TITLE_5:
    'Which group of visitors do you want tot reach with your engagement campaign?',
  MESSAGE_CATEGORY: 'Message category',
  SELECT_MESSAGE_CATEGORY: 'Select a Message category',

  PREVIEW: 'Preview',

  START: 'Inflow batch details ',
  END: ' Outflow batch details',
  'DATE/TIMEINFO': 'General batch details with all the other fields',
  PRICECATEGORIES: 'Batch pricing details',
  PERIOD_INFO: 'Event batch duration details',

  SELECT: 'Select',
  CONTRIBUTORS: 'contributers',
  PRODUCTS: 'Products',
  CHOOSE_YOUR_PRODUCTS: 'Choose your products',
  SETTINGS_SAVE_OK: 'Settings saved correctly',
  SETTINGS_SAVE_KO: 'Error in saving settings',
  MY_VISIT: 'My visit',
  EVENTS: 'Events',
  SETTINGS: 'Settings',
  INTERESTED_IN: 'I am interested in events for',
  SELECT_LOCATION: 'Select a location',
  SELECT_EVENT: 'Select an event',
  SELECT_TIME_PERIOD: 'Select a time period',
  SELECT_FROM: 'From',
  SELECT_UNTIL: 'Until',
  SELECT_WINNER: 'Select winner',
  BACK: 'Back',
  COMMUNICATION_CENTER: 'Communication center',
  SAVED_COMMUNICATION: 'Saved Communication',
  NEW_COMMUNICATION: 'New communicaton',
  COMMUNICATION: 'Communication',
  COMMUNICATIONS: 'Communications',
  TYPE: 'Type',
  DATE: 'Date',
  TIME: 'Time',
  CHOOSE_EVENT_OPTION: 'Choose an event option',
  CHOOSE_BATCHGROUP_OPTION: 'Choose an batchgroup option',
  ENGAGEMENT_CAMPAIGN: 'Start an Engagement Campaign',
  ENGAGEMENT_CAMPAIGN_SUB: 'Used for the promotion of the event and catering.',
  CATERING_PROMOTION: 'Catering promotion',
  SECOND_PROMOTION: 'Second promotion',
  PLANBOARD: 'Planboard',
  MY_PLANBOARD: 'My planboard',
  SHOW_PLANBOARD: 'Show planboard',
  WHOM: 'Whom',
  SEND_MESSAGE_TO: 'Send message to',
  WHAT: 'What',
  TITLE_MESSAGE: 'Title message',
  LINK_TEXT: 'Outbound link',
  TEXT_MESSAGE: 'Text message',
  PROMOCODE: 'Promotioncode',
  ADD_FAVORITE: 'Add to favourites',
  FAVORITE: 'Favorite',
  WHEN: 'When',
  NEW_MESSAGE: 'New message',
  SINGLE_MESSAGE: 'Send a single message',
  SINGLE_MESSAGE_SUB: 'Used for updates or extra information to your visitors.',
  THE_LOTTERY: 'The Lottery',
  START_LOTTERY: 'Start the Lottery',
  FIRST_PROMOTION: 'First promotion',
  MESSAGE: 'Message',
  MESSAGES: 'Messages',
  ERROR_HEADER: 'Looks like something went wrong.',
  ERROR_NO_CONNECTION:
    'A problem occurred, please contact the customer support center from The Driving Force',
  USER_PASSPORT: 'Passport',
  USER_PICTURE_UPLOAD: 'Add Your Photo to make your account personal',
  USER_QR_CODE:
    'This is your personal QR code, you can scan this code to recieve stamps which with a full set of stamps allows you to recieve discount. ',
  DISCOUNT: 'Discount',
  ITEM_NUMBER: 'Item number',

  EVENT_FLEX_ARRIVAL: 'Percentage flexible users',
  EVENT_AVERAGE_WAITTIME: 'Average waittime',
  EVENT_MAX_WAITTIME: 'Max Waittime',
  EVENT_AVERAGE_DEVIATION: 'Average deviation',
  EVENT_MAX_DEVIATION: 'Max deviation',
  DISTRIBUTION_IN_TIME: 'DIT',
  DISTRIBUTION_IN_TIME_BIG: 'Distribution in time',
  DISTRIBUTION_IN_PLACE: 'DIP',
  ERROR_LOGIN: 'Error, wrong data',
  ERROR: 'Error',
  ERROR_EMAIL_EXIST: 'email exist',

  TITLE_CHART_0: 'Visitors',
  TITLE_CHART_1: 'Waittime',
  TITLE_CHART_2: 'Entries',
  TITLE_CHART_3: 'Incidents',
  TITLE_CHART_4: 'Inflow patern visitors',
  TITLE_CHART_5: 'Outflow patern',
  EMPTY_SLOT: 'Empty slot',
  MOVE_SLOT_FORWARD: 'Move slot',
  EVENT_TITLE: 'Event dashboard',
  INCIDENT_TITLE: 'Incident',
  INCIDENT_TITLE_2: '',
  TOTAL_ARRIVALS: 'Total arrivals',

  // Growthvitamin / Groeivitamine / Growth vitamin / Groei vitamine CARDS
  DISCOUNT_ORDER: 'discount on your entire order',
  DISCOUNT_PRODUCT: 'discount on product',
  AVAILABLE_UNTIL: 'Available until',
  AWARD_VITAMIN: 'Special Offer',
  GROWTH_VITAMIN_EXPIRE_TEXT: 'Offer expires at %s',
  GROWTH_VITAMIN_MIN_VALUE_TEXT: 'Valid from an order value of € %f',

  // Homepage
  USER_LOGGED_OUT: 'Succesfully logged out',
  NO_CONTINUE_USING_WEBSITE: 'No I want to use the website',
  VIEW_ACTIVITIES: 'View',
  SEARCH_ACTIVITY: 'Search an activity',
  SEARCH_PRODUCTS: 'Search products',
  ACTIVITIES_DESC:
    'Browse through the themes and find activities to your liking',
  ACTIVITIES_FOR_HIGHLIGHT: 'Activities for highlight ',
  ACTIVITIES_FOR_LOCATION: 'Activities for location ',
  CLOSE_ACTIVITIES: 'Close this window',
  GET_ACCOUNT_APP: 'Download the accountName app to start bidding',
  ACCOUNT_APP_TEXT:
    'Get the accountName app and be inspired about all your can see and do. The accountName-app offers you a lot of benefits for your visit to ' +
    'accountName. Easily find, book and access your favorite activities in a few finger ticks.',
  ACCOUNT_APP_TEXT2:
    'The accountName app is all you need to get the most out of your visit to accountName.',
  WHATS_ON: "What's on",
  WHATS_ON_DESC: 'What’s where ',
  FILTER_RESULTS: 'Filter results',
  TODAY: 'Today',
  NEXT_7_DAYS: 'Next 7 days',
  NEXT_30_DAYS: 'Next 30 days',
  NEXT_3_MONTHS: 'Next 3 months',
  SELECT_SPEC_DAYS: 'Select specific days',
  WHAT_IS_WHERE: "What's where",
  WHAT_IS_WHERE_DESC: "See what's where on ",
  ACTIVITIES: 'Appointments',
  ACTIVITIES_HOMEPAGE: 'Activities',
  ACTIVITIES_TITLE: 'Browse our activities',
  GET_PERS_SUG:
    'Get personalized suggestions by selecting categories with the switches on the left. ',
  USER_WELCOME: 'Welcome back ',
  PASS_MAX_FUN: 'Create a passport for maximum fun',
  PERS_PASS: 'Your personal passport',
  CREATE_PASS_DESC_1:
    'Create your personal passport and get the most out of your visit to ',
  CREATE_PASS_DESC_2:
    'The passport offers you access to exclusive activities and discounts and enables you to fully customize your visit according to your desires and interests. you are guaranteed to have more fun. ',
  CREATE_PASS_NOW: 'Create your personal passport now! ',
  CREATE_PASS: 'Create passport',
  PASS_DESC_1: 'Continue planning your visit or create a new trip to ',
  PASS_DESC_2:
    'Go to your personal passport to view your saved favourites, personal suggestions and interests.',
  GO_TO_PASS: 'Go to Account',

  // QR-code scanner
  QR_CODE: 'QR-code scanner',
  ENTER_AMOUNT: 'Enter the amount of Euros',
  SCAN_CODE: "Scan customer's QR-code",
  ERROR1: 'You have not entered anything!',
  LAST_RESULT: 'Last result:',

  // User passport
  USER_WANT_LOGOUT: 'Yes, I want to log out',
  USER_PASSPORT: 'My account',
  USER_PASSPORT_DESC:
    'Create your personal passport to get personalizes activity suggestion, earn special rewards and view your favourite list.',
  USER_INTERRESTS: 'Your interests',
  USER_INTERRESTS_DESC:
    'Let us know what activities you’re interested in, so we can offer matching activities. ',
  YOUR_USER_REWARD_LVL: 'Your current reward level',
  USER_REWARD_LVL: 'Reward level',
  USER_CURRENT_LEVEL: 'Current level',
  USER_REWARD_LVL_DESC:
    'Earn reward points by doing activities. Get enough points to reach the next level and unlock special activities and discounts. ',
  USER_FAVORITES: 'Your favorites',
  USER_FAVORITES_DESC: 'Activities you added to your favourites list. ',
  USER_REWARD_POINTS: 'Points',
  USER_EARNED_POINTS: 'Earned points',
  USER_POINTS_TO_NEXT_LEVEL: 'Points to next level',
  USER_INTERESTS: 'My interests',
  DEL_FAV: 'Deleting favorite',
  SURE_DELETE_ACTIVITY: 'Are you sure you want to delete the activity ',
  SURE_DELETE_FAV: ' from your favorites list ? ',
  USER_DETAILS: 'Personal details',
  USER_SELECTIONS: 'Your selections',
  USER_LOCATION_NOT_FOUND: 'Address not found',
  USER_LOCATION_NOT_FOUND_DESC: 'The address could not be found',
  USER_LOCATION_NOT_FOUND_DESC2:
    'Something went wrong while saving your data, please try again later',
  USER_DETAILS_NOT_SAVED: 'User details are not saved',
  USER_DETAILS_SAVED: 'The user details are saved',
  GETTING_USER_INTERESTS: 'Getting user interests',
  FILTER_ACTIVITIES: 'Filter activities',

  // Incidents
  INCIDENT_DESCRIPTION_REPORTER: 'Description of the reporter',
  INCIDENT_DESCRIPTION: 'Add a description',
  INCIDENT_HAPPEND: 'What kind of incident is involved',
  INCIDENT_FILL_IN: 'Fill incident data in',
  INCIDENT_TYPE: 'Type incident',
  INCIDENT_LIFE_THREAT: 'Levensbedreigend?',
  INCIDENT_SITUATION: 'Life threatening?',
  INCIDENT_LOCATION:
    'True? (right click on the map where the incident happened).',
  INCIDENT_EXACT_LOCATION: 'Specify the location',
  INCIDENT_DESCRIPTION: 'Explanation incident',
  INCIDENT_ROAD_ID: 'Road data',
  INCIDENT_ADRESS: 'Address data',
  INCIDENT_YES_NO: 'Yes/No',
  INCIDENT_GPS: 'GPS coordinates',
  INCIDENT_STREET: 'Street name',
  INCIDENT_NUMMER: 'Number',
  INCIDENT_PLACE: 'City name',
  INCIDENT_DESCRIPTION_PLACEHOLDER:
    'Description of the exact location for the emergency services.',
  INCIDENT_ADDITIONAL_LOCATION: 'Addition location',
  INCIDENT_PHOTO: 'Add comments and photo.',
  INCIDENT_USER: 'Name of the reporter',
  NO_INCIDENT_DATA: 'No incident data',
  INCIDENT_DIALOG_CLOSE: 'Are you sure you want to close this incident?',
  INCIDENT_DIALOG_EDIT: 'Do you want to save the changes?',
  GO_INCIDENT: 'View',
  NO_USERS: 'No users found',
  INCIDENT_CLOSE: 'Close incident',
  INCIDENT_REMOVED: 'Incident removed',
  INCIDENT_NOT_REMOVED: 'Incident fails to remove',
  INCIDENT_DIALOG_CLOSE: 'Are you sure you want to close this incident?',
  INCIDENT_DIALOG_EDIT: 'Do you want to save the changes?',
  INCIDENT_SEND: 'Send',
  INCIDENT_EDIT: 'Save changes',
  INCIDENT_PICTURE: 'Incident picture',

  INC_1: 'Traffic incident',
  INC_2: 'Debris',
  INC_3: 'Wounded',
  INC_4: 'Too crowded',
  INC_5: 'Technical failure',
  INC_6: 'Traffic accident',
  INC_7: 'Fire',
  INC_8: 'Suspicious situation',
  YES: 'Yes',
  NO: 'No',
  YES_SEND_MSG: 'Yes - send message',
  SEND_MSG_TO_TS: 'Send message to time-slot: ',
  SEND_MSG_TO_TS_CHECK:
    'Are you sure you want to send a message to all the users from time-slot: ',
  ON_THE: ' on the ',
  ENTER_TITLE_MSG: 'Enter the title for the message',
  ENTER_TEXT_MSG: 'Enter the text of the message',

  // Event
  EVENT_ADD_REWARD_LEVEL: 'Add reward level',
  EVENT_ASSIGN_REWARDS: 'Assign rewards',
  EVENT_REWARD_MANAGEMENT: 'Rewards management',
  EVENT_ASSIGN_REWARD_EXPLANATION:
    'To assign a reward to this event, please save the event first!',
  EVENT_REWARD_EXPLANATION:
    'To add a reward level to this event, please save the event first!',
  EVENT_DISCOUNT_CARDS_EXPLANATION:
    'To add a discount card, please save the event first!',
  EVENT_DISCOUNT_CARDS: 'Discount cards',
  EVENT_SUBACTIVITIES: 'SubActivities',
  EVENT_ALTERNATIVES: 'Alternatives',
  EVENT_TICKET_TYPES: 'Ticket types',
  EVENT_EXTRA: 'Extra event',
  EVENT_STOP_NAME: 'Event stop name',
  EVENT_END_LOCATION: 'End location',
  EVENT_START_LOCATION: 'Start location',
  EVENT_LOCATION: 'Event Location',
  EVENT_ROUTE: 'Event route',
  EVENT_RESET: 'Reset',
  EVENT_RANKING: 'Event ranking',
  EVENT_PARTNER: 'Event partner',
  EVENT_PRODUCT: 'Event/Products',
  EVENT_DATE_RANGE: 'Date range',
  EVENT_AGE_RESTRICTIO: 'Age restrictio',
  EVENT_ACTIVE_COMPLETE_TIME: 'Activate complete time',
  EVENT_CHECK_IN_TIME: 'Check-in time',
  EVENT_CHECK_OUT_TIME: 'Check-out time',
  EVENT_ACTIONS: 'Actions',
  EVENT_EARLIEST_CHECKIN_TIME: 'Earliest check-in time',
  EVENT_LATEST_CHECKIN_TIME: 'Latest check-in time',
  EVENT_DURATION_ARRIVAL_BATCHES: 'Duration arrival batches',
  EVENT_MAX_INFLOW: 'Max inflow',
  EVENT_EARLIEST_CHECKOUT_TIME: 'Earliest check-out time',
  EVENT_LATEST_CHECKOUT_TIME: 'Latest check-out time',
  EVENT_DURATION_DEPARTURE_BATCHES: 'Duration departure batches',
  EVENT_MAX_OUTFLOW: 'Max outflow',
  EVENT_STEPS: 'Steps',
  EVENT_MINIMAL_DURATION: 'Minimal duration',
  EVENT_MAXIMUM_DURATION: 'Maximum duration',
  EVENT_BOOKING_POLICY: 'Booking policy',
  EVENT_FLEX_PERCENTAGE: 'Flex percentage',
  EVENT_PRICE_CATEGORY: 'Price category',
  EVENT_ADD_PRICE_CATEGORY: 'Add Price category',
  EVENT_THRESHOLD: 'Threshold',
  EVENT_PLEASE_ADD_PRICECATEGORY:
    'Please add at least 1 price category to this batchgroup',
  EVENT_EXTERNAL_PLATFORM: 'External platforms',
  EVENT_TOUR: 'Tours',
  EVENT_PRICE_INFORMATION: 'Price information',
  EVENT_CHART_EXPLANATION:
    'If you make a choice for a date and a location, a graph is created to show the crowds.',
  EVENT_AVERAGE_SPEED: 'Average speed (km/h)',
  EVENT_DELIVERY_OR_TAKEAWAY:
    'If possible, make a choice if you want the product to be delivered or to collect it yourself.',
  EVENT_INSERT_STARTTIME: 'Insert your new start time',
  EVENT_INSERT_ENDTIME: 'Insert your new end time',
  EVENT_CURRENT_START_AND_ENDTIME:
    'Your current start and end time for event: eventName is',
  EVENT_CURRENT_START_AND_ENDDATE:
    'Your current start and end date for event: eventName is',
  EVENT_NO_TICKETS_SELECTED: 'No tickets are selected',
  EVENT_PLEASE_SELECT_TICKET: 'Select please your tickets',
  EVENT_NO_DATE_CHOSEN: 'No date chosen',
  EVENT_CHOOSE_DATE: 'Please choose a date',
  EVENT_BOOK: 'Book Event',
  EVENT_INPUT_TIME_INCORRECT: 'The start time is later than the end time',
  EVENT_TIME_INCORRECT: 'Time incorrect',
  EVENT_PREFERRED_ARRIVAL: 'Preferred arrival time',
  EVENT_PREFERRED_DEPARTURE: 'Preferred departure time',
  EVENT_STARTS_EVERY: 'Starts every',
  NO_EVENT: 'No events found',
  NO_EVENTS_NOW_FOR_PARTNER: "There aren't events found for this partner",
  NO_EVENTS_NOW_FOR_ACCOUNT: "There aren't events found for this account",
  EVENT: 'Event',
  EDIT_EVENT: 'Edit event',
  EVENT_EDIT: 'Select an event to edit',
  EVENT_REGISTRATION: 'Event registration',
  EVENT_DURATION: 'Duration of the event',
  EVENT_DESC_SHORT: 'Description',
  EVENT_LOC_SHORT: 'Location',
  EVENT_CAP_SHORT: 'Capacity',
  EVENT_CAT_SHORT: 'Categories',
  EVENT_PIC_SHORT: 'Picture',
  EVENT_BUDGET_SHORT: 'Budget',
  EVENT_PARTOF_SHORT: 'Part of -Themes-',
  EVENT_TW_SHORT: 'Time-Window',
  EVENT_PIC_NONE: 'No picture available',
  EVENT_VISIBILITY: 'Visible for',
  EVENT_NAME: 'Name of event',
  EVENT_TYPE: 'Type of event',
  EVENT_DESCRIPTION: 'Description of the event',
  EVENT_STARTTIME: 'Start time of the event',
  EVENT_ENDTIME: 'End time of the event',
  EVENT_INTERVAL: 'Interval',
  EVENT_MAXCAPACITY: 'Maximum capacity per interval',
  EVENT_INFLOWCAPACITY: 'Capacity per interval',
  EVENT_PRICE: 'Event price',
  EVENT_MAX_WAIT_TIME: 'Max waiting time in minutes',
  EVENT_HISTORIC_ARRIVAL: 'Historical arrivals',
  EVENT_LANGUAGE: 'Language specifics',
  EVENT_FILTERTYPE: 'Filter events on type: ',
  EVENT_AGENDA_NEW: '"New agenda item',
  EVENT_DATES_SELECTION: 'Selection of dates',
  EVENT_DAYS_SELECTION: 'Selection of days',
  EVENT_START_DATE: 'Start-date',
  EVENT_END_DATE: 'End-date',
  EVENT_START_TIME: 'Start-time',
  EVENT_END_TIME: 'End-time',
  EVENT_MAX_INFLOW: 'Max inflow',
  EVENT_RATE_PRICE: 'Rate price',
  EVENT_REWARD_POINTS: 'Reward points',
  EVENT_NO_BATCHGROUPS: 'No agenda items available',
  EVENT_MESSAGE_TITLE: 'Message title',
  EVENT_MESSAGE_TEXT: 'Message text',
  EVENT_MESSAGE_REW_LVL: 'Send message to reward level',
  EVENT_USER_SELECTION: 'Selection of users',
  EVENT_DATE: 'Date',
  EVENT_TIME: 'Time',
  EVENT_COMM_TYPE: 'Communication type',
  EVENT_MESSAGE_STATUS: 'Message status',
  EVENT_MESSAGE_SEND: 'Send',
  EVENT_MESSAGE_NOT_SEND: 'Not send',
  EVENT_MESSAGE_PICTURE: 'Message picture',
  EVENT_MESSAGE_PRODUCT: 'Product',
  EVENT_MESSAGE_PRODUCT_OPT: 'Product (optional)',
  EVENT_MESSAGE_SELECT_PRODUCT: 'Select a product',
  EVENT_ERROR_MSG_1:
    'It seems like you have not (correctly) filled in all the required fields.',
  EVENT_ERROR_MSG_2: 'Please fill in all the required fields to continue.',
  EVENT_DEL_AGENDA_ITEM: 'Are you sure you want to delete this agenda item?',
  EVENT_DEL_MESSAGE: 'Are you sure you want to delete this message?',
  DELIVERY_PARTNER: 'Delivery partner',
  DELIVERY_IMPROVEMENT_1: 'Your products with an order value of: ',
  DELIVERY_IMPROVEMENT_2: 'can be deliverd for free with an order value of: ',

  /// / Event info buttons on the event wizard
  // Event detail screen
  EVENT_FORAGE_MESSAGE:
    'This product has a (age)+ rating. Can you confirm You are of the right age',
  EVENT_NAME_INFO:
    "The 'Name of event' determines the name for this event. The Event Name will be visible for customers in the calendar overview.",
  EVENT_TYPE_INFO: "The 'Type of event' determins the type of this event.",
  EVENT_TW_INFO:
    "The 'Time-Window' of an event is either 'Fixed' or 'Repetitive'. If the event occures more than once a day, the event is 'Repetitive'.",
  EVENT_LOC_INFO:
    "The 'Location' is the location in which the event is held. The Location will be visible for customers in the calendar overview.",
  EVENT_PARTOF_INFO:
    "An event can be 'part of' multiple themes. If the event fits seamlessly by a theme, than this event should be added to that theme.",
  EVENT_CAP_INFO: "The 'capacity' is the maximum capacity of the event.",
  EVENT_BUDGET_INFO:
    "The 'Budget' is the budget for an event how many times it will be suggested for a customer based on the 'rate price' of the event.",
  EVENT_LEAD_INFO:
    "The 'Lead-Time' is the amount of lead time in minutes for the event (default set to 0).",
  EVENT_COOL_INFO:
    "The 'Cooldown-Time' is the amount of cooldown time in minutes for the event (default set to 0).",
  DURATION_INFO:
    "The 'Duration' is the duration in minutes for the event (default set to 60).",
  EVENT_DESC_INFO:
    "The 'Description' of the event is a brief introduction of the event. The Description will be visible for customers in the event details screen.",
  EVENT_PIC_INFO:
    "The 'Picture' of the event will be visible for customers in the calendar overview and when a customer opens an event for information / to book.",
  EVENT_YT_LINK_INFO:
    'The youtube link is provided to let the user open up the link in the youtube application or in web.',
  // Event agenda screen
  EVENT_BG_TYPE_INFO:
    'The availability of an agenda item determines how often the agenda item is available. Either specific for specific days or 1 day, or repeating when the agenda item repeats itself.',
  EVENT_DATES_SEL_INFO:
    "The 'Selection of dates' are the dates on which the Specific agenda item is held. Multiple days as an input are possible.",
  EVENT_DAYS_SEL_INFO:
    "The 'Selection of days' are the days in which the repeating agenda item is held. Multiple days as an input are possible.",
  EVENT_START_DATE_INFO:
    "The 'Start-date' is the starting date in which the agenda item is held",
  EVENT_END_DATE_INFO:
    "The 'End-date' is the final date in which is the agenda item is held",
  EVENT_START_TIME_INFO:
    "The 'Start-time' is the starting time of the agenda item.",
  EVENT_END_TIME_INFO: "The 'End-time' is the end time of the agenda item.",
  EVENT_INTERVAL_INFO:
    'The interval is the duration (in minutes) between the end of a single agenda item and the start of the next single agenda item',
  EVENT_DURATION_INFO:
    'The duration of the agenda item is the length (in minutes) from a single agenda item which is possible to set multiple times a day.',
  EVENT_MAXINFLOW_INFO:
    "The 'Max inflow' is the maximum amount of people that can enter the location at the same time",
  EVENT_PRICE_INFO:
    "The 'Event price' is the price to pay for a visitor for this agenda item.",
  EVENT_RATE_PRICE_INFO:
    "The 'Rate price' is the price you are willing to pay extra whenever the agenda item is suggested to a visitor.",
  EVENT_REWARD_POINTS_INFO:
    "The 'Reward points' is the points a visitor can get when the visitor books this agenda item.",
  // Event communication screen
  EVENT_MSG_TITLE_INFO: "The 'Message title' is the title of the message.",
  EVENT_MSG_TEXT_INFO: "The 'Message text' is the text of the message.",
  EVENT_MSG_RWD_LVL_INFO:
    'Each event has three reward levels, click on one of the reward levels to specify the users to send a message to.',
  EVENT_MSG_USER_SEL_INFO:
    'You can choose to send a message to the subscribed users for the event, the un-subscribed users or both.',
  EVENT_MSG_DATE_INFO: 'Choose the date on which you want to send the message.',
  EVENT_MSG_TIME_INFO: 'Choose the time on which you want to send the message.',
  EVENT_MSG_COMM_TYPE_INFO:
    'Choose the platform type of communication for the to be send message.',

  NEW_QUADRANT: 'Create new quadrant',
  TYPE_QUADRANT: 'Type of quadrant',
  TYPE_OBJECT: 'Object',
  SELECT_SIGNALS: 'Select signals',
  NO_INCIDENT: 'No incident',
  CONFIRM: 'Confirm',
  SELECTED_EVENT: 'Selected event',

  // Batchgroup

  BATCHGROUP_NAME: 'Name of the batchgroup',
  BATCHGROUP_EDIT: 'Edit batchgroup',
  BATCHGROUP_DELETE: 'Delete batchgroup',
  BATCHGROUP_CONF_DELETE: 'Are you sure want to delete the batchgroup: ',
  BATCHGROUP_DESCRIPTION: 'Description of the batchgroup',
  BATCHGROUP_CHAINBOX: 'Batchgroup contains chainable batches',
  BATCHGROUP_STARTTIME: 'Start time of the batchgroup',
  BATCHGROUP_ENDTIME: 'End time of the batchgroup',
  BATCHGROUP_STARTDATE: 'Startdate of the batchgroup',
  BATCHGROUP_ENDDATE: 'Enddate of the batchgroupp',
  BATCHGROUP_DATES: 'Dates of the batchgroup',
  BATCHGROUP_INTERVAL: 'Batches start every ....(min)',
  BATCHGROUP_INTERVAL_END: 'Batches end every ....(min)',
  BATCHGROUP_CAPACITYPERBATCH: 'Capacity per batch',
  BATCHGROUP_DURATION: 'Duration of the batch',
  BATCHGROUP_TYPERE: 'Repeating timewindow(s)',
  BATCHGROUP_ADD: 'Add batchgroup',
  BATCHGROUP_DETAILS: 'Batchgroup details',
  BATCHGROUP_CHOOSETYPE: 'Choose a batchgroup type',
  BATCHGROUP_DAYS: 'Select the day(s) in which the event occurs',
  BATCHGROUP_NOPASTDATE: 'Please select a date that is not in the past',
  BATCHGROUP_TYPESP: 'Specific date(s)',

  // External calendar
  EXTERNAL_CALENDAR: 'External calendar',
  EXTERNAL_CALENDAR_ADD: 'Add external calendar',
  EXTERNAL_CALENDAR_DELETE: 'Delete external calendar',
  EXTERNAL_CALENDAR_CONF_DELETE:
    'Are you sure you want to delete the following calendar: ',

  // Products
  PRODUCT_CATEGORIES: 'Product categories',
  PRODUCT_CATEGORY_EXPLANATION:
    'To add a product category for this event, please save the event first!',
  PRODUCT_ADD_CATEGORY: 'Add product category',
  PRODUCT_IN_STOCK: 'In stock',
  PRODUCT_DELETE: 'Delete product',
  PRODUCT_ASPECT_DELETE: 'Delete aspect',
  PRODUCT_ITEM_DELETE: 'Delete item',
  PRODUCT_PRICE_CATEGORY_DELETE: 'Delete price category',
  PRODUCT_CONF_DELETE: 'Are you sure want to delete this product: ',
  PRODUCT_ASPECT_CONF_DELETE: 'Are you sure want to delete this aspect: ',
  PRODUCT_ITEM_CONF_DELETE: 'Are you sure you want to delete the chosen item? ',
  PRODUCT_PRICE_CATEGORY_CONF_DELETE:
    'Are you sure you want to delete the chosen price category',
  VIEW_PRODUCT: 'Viewing product',
  CREATE_PRODUCT: 'Creating a product',
  PRODUCT_CATEGORY: 'Product category',
  PRODUCT_NAME: 'Name of the product',
  PRODUCT_PRICE: 'Price of the product',
  PRODUCT_DESCRIPTION: 'Description of the product',
  PRODUCT_VAT: 'VAT % of the product',
  PRODUCT_BRAND: 'Brand name of the product',
  PRODUCT_PICTURE: 'Picture of the product',
  PRODUCT_CATEGORIES: 'Categories of the product',
  PRODUCT_CAPACITY: 'Product capacity',
  PRODUCT_AGE: 'Minimum age for product',
  PRODUCTS_ADD_MORE: 'Add more',
  PRODUCT_SOLD_OUT: 'Sold out',
  PREPARATION_INSTRUCTION_BTN: 'Instruction',
  PREPARATION_INSTRUCTION_TITLE: 'Preparation instruction',
  PRODUCT_LEAD_TIME_ALERT: 'This product has a minimum delivery time of',
  PRODUCT_DATE_TIME_ALERT: 'This product can be ordered from',
  PRODUCT_DATE_TIME: 'to',
  INCL_VAT_TEMPLATE: 'incl. %s VAT',
  EXCL_VAT_TEMPLATE: 'excl. %s VAT',
  INCL_VAT: 'incl. VAT',
  EXCL_VAT: 'excl. VAT',

  // Rental
  RENTAL_PERIOD: 'Choose a date',
  CHECK_AVAILABILITY: 'Save period info',

  // Login
  LOGIN_YOUR_EMAIL: 'Your email address',
  LOGIN_YOUR_PASSWORD: 'Your password',
  LOGIN_NO_ACCOUNT_YET: 'No account yet?',
  LOGIN_ACCOUNT_CREATION: 'Create an account',
  LOGIN_REPEAT_EMAIL: 'Please repeat your email address',

  // Linda input
  LINDA_SUGGESTIONS_DIALOG: 'Linda is getting the suggestions',
  LINDA_FOOD_AND_BEVERAGE:
    'Here you can add food and beverage before or after your event',
  LINDA_ADD_FOOD_BEFORE: 'Add food and beverage before your event',
  LINDA_ADD_FOOD_AFTER: 'Add food and beverage after your event',
  LINDA_SEARCHING: 'Linda is searching for your selected event',
  LINDA_LOGIN_WELCOME: 'Welcome, my name is Linda.',
  LINDA_LOGIN_HELPING_HAND:
    'I will help you plan a day away, to ensure you, you will get the maximum out ot your day away and bypass the crowds.',
  LINDA_LOGIN_SHORT_INFO:
    'With Linda you can make a appointment within 5 minutes. With this appointment Linda ensures that your day is careless and without traffic jams or queues.',
  LINDA_WELCOME: 'Welcome!',
  LINDA_REGISTER_USERINFO:
    'To start off, i need some information, so i know for who i am planning.',
  LINDA_REGISTER_LATER:
    'This way i can notice you in a later stage for your appointment.',
  LINDA_REGISTER_DONE: 'Thanks for registering!',
  LINDA_REGISTER_MAIL:
    ' Finished! Thanks for creating your accountName passport. We’ve sent you a confirmation email with a link to activate your passport. Please press the link to activate your passport. Check your spam folder in case you didn’t receive the conformation email. ',

  LINDA_BIGGER_GAP_OR_GROUPSIZE:
    'Try to make the time gap bigger and/or the groupsize smaller.',
  LINDA_ACCOUNT_CREATION_FIRST_STEP: 'Great! Your account has been made',
  LINDA_ACCOUNT_CREATION_FIRST_STEP_DESC:
    'I have send you an email with a link.\nClick on the link in your email to activate your account',
  LINDA_ACCOUNT_CREATION: 'Welcome!',
  LINDA_WELCOME_BACK: 'Welcome back!',
  LINDA_ACCOUNT_READY_TO_CREATE:
    'To begin I need to know who you are, so I can create an account for you.',
  LINDA_USER_TRIPLIST:
    'Look at your appointments or create a new one. You can retrieve your tickets by clicking on a appointment.',
  LINDA_WHERE_TO: 'Where do you want to go?',
  LINDA_SEARCH_EVENT: 'Choose an event to continue',
  LINDA_DATE_PICKER_WELCOME: 'Allright, lets choose a date.',
  LINDA_DATE_PICKER: 'When are you planning to leave?',
  LINDA_SPECIAL_CODE: 'Have you received a VIP code in the mail?',
  LINDA_TRIP_DETAIL:
    'With whom you want to go and at what time do you think you will arrive and leave?',
  LINDA_ACTIVITY_LIST:
    'I want to create a list of the activitites you want to see and do. By doing this, i will make sure you can surely visit all of them.',
  LINDA_ADJUST_INFO: 'These info is adjustable in a later stage.',
  LINDA_MODE_OF_TRANSPORT: 'How are you planning to travel?',
  LINDA_SAVING_A_SPOT:
    'This way i can help you save a parking spot or check if there is any public transport/shuttle bus available.',
  LINDA_CHECK_INPUT:
    'Please check all the data, so we can ensure nothing goes wrong.',
  LINDA_MEETING_SET: 'The booking process has been completed',
  LINDA_MEETING_SET2:
    'Your booking request has been forwarded to our partner for confirmation.',
  LINDA_ERROR: 'Something went wrong.',
  LINDA_ERROR_PAYMENT: 'Your payment has not been received. Check your account',
  LINDA_ADJUST_TIME:
    'You can change the time and mode of transport if it is not correctly anymore.',
  REGISTER_LINDA: 'Register',
  LINDA_EVENT_NAME: 'Choose a event',
  LINDA_VIP: 'Discount code',
  LINDA_VIP_DIALOG:
    'If you have recieved a discount code in your mail, please enter it below or press next.',
  LINDA_USERGROUP_DIALOG:
    'If you have recieved a special code, please enter it below',
  LINDA_VIP_INPUT: 'Please enter your discount code here',
  LINDA_GROUP_SIZE: 'Group size',
  LINDA_GS_INPUT: 'Set groupsize',
  LINDA_ARRIVAL: 'Expected arrival',
  LINDA_ARRIVAL_LABEL: 'Arrival time',
  LINDA_DEPARTURE_LABEL: 'Departure time',
  LINDA_DEPARTURE: 'Expected departure',
  LINDA_TRANSPORT_TYPE: 'Transport type',
  LINDA_ATTEND: 'What do you want to attend?',
  LINDA_NO_SUBEVENTS: 'There are no sub-events available',
  LINDA_FILL_REQUIRED: 'Please fill in all the required fields',
  LINDA_NEW_APPOINTMENT: 'New appointment',
  LINDA_APPOINTMENTS: 'Your appointments',
  LINDA_NO_APPOINTMENTS: 'No appointments',
  LINDA_GO_TO_APPOINTMENTS: 'Go to my activities',
  LINDA_ORDER: 'Your order',
  LINDA_STARTTIME: 'Start time',
  LINDA_ENDTIME: 'End time',
  LINDA_DELETE_APPOINTMENT: 'Are you sure you want to delete the appointment?',
  LINDA_CALENDAR_CROWDED: 'Crowded ',
  LINDA_CALENDAR_CALM: 'Calm ',
  LINDA_CALENDAR_AVERAGE: 'Average ',
  LINDA_CALENDAR_SELECTED: 'Selected ',
  LINDA_TRANSPORT_MODE: 'Mode of transport',
  LINDA_NO_TRANSPORT_AVAILABLE: 'There is no mode of transport available',
  LINDA_MANDATORY_TRANSPORT: 'Please select a mode of transport to continue',
  LINDA_TOTAL_PRICE: 'Total Price',
  LINDA_CANCEL_ORDER: 'Cancel',
  LINDA_CONFIRM_ORDER: 'Confirm',
  LINDA_ORDER_FAILED:
    'The appointment has been deleted, please check your mail for further instructions.',
  CLOSE: 'Close',
  LINDA_REGISTER_TO: 'Register to...',
  LINDA_MISS_NOTHING: 'Miss nothing',
  LINDA_OWN_PROGRAM: 'Create your own program',
  LINDA_AVOID: 'Avoid queues',
  LINDA_PLAN_VISIT: 'Plan your visit with Linda',
  LINDA_ENJOY: 'Enjoy to the fullest',
  LINDA_ADVANTAGE: "Take advantage of extra's and discounts",
  LINDA_ACCOUNT_MADE_TITLE:
    'Great! The account is made. To activate the account I need the style of your company.',
  LINDA_ACCOUNT_MADE_BODY:
    "I will make sure your account will look like it's yours",
  LINDA_NONE: 'None',
  LINDA_PLANNED_SUCCESSFULL: 'A confirmation email has been sent',
  LINDA_PLANNED_SUCCESSFULL2:
    'You will receive a message when the partner has confirmed or rejected your booking request.',
  LINDA_KEEPS_PROMISE: 'The appointment can be found in my activities',
  LINDA_TICKETS_TO_MAIL:
    "i've send the tickets in the mail to your mail account!",
  LINDA_TICKET_INFO_ACCOUNT:
    'You can also retrieve the tickets by clicking on the information of your appointment.',
  LINDA_BG_MEANING:
    'To spread the users over your facilities, you need to create batchgroups. These batchgroups exist from different batches.',
  LINDA_BG_FILLING:
    'With this, i can plan the users in for different batches and make sure all batches are well filled.',
  LINDA_THEME: 'Theme',
  LINDA_GETTING_EVENTS: 'Linda is getting the events',
  LINDA_CHECK_YOUR_ORDER: 'Check your choices',
  LINDA_PLEASE_FILL_IN: 'Please fill the fields in',

  // Web stepper two

  STEP_THEME: 'Selecting the theme',
  STEP_DETAILS: 'Trip details',
  STEP_WISHLIST: 'Wishlist',
  STEP_PLAN: 'Plan your day',
  STEP_TRANSPORT: 'Transport mode',
  STEP_ISSUES: 'Issues',
  STEP_CONFIRM: 'Confirmation',

  PREVIOUS: 'Previous',
  CONTINUE: 'Continue',
  NEXT: 'Next',
  CANCEL: 'Cancel',
  CANCEL_TOOLTIP: 'Cancel',
  LOGIN: 'Login',
  USERNAME: 'Username',
  PASSWORD: 'Password',
  LOGIN_TEXT: 'Already got an account?',
  REGISTER_TEXT: 'Create an account',
  ACTIVATION_CODE_REQUIRED: 'activation code is required',
  ACTIVATION_CODE_TITLE: 'Activation code: ',
  ACTIVATION_CODE_TEXT:
    'Please enter the activation code you received by email after creating your account. ',
  ACTIVATION_CODE_INPUT: 'Enter your activation code',
  ALERT:
    'The app is not yet available. You will receive an email as soon as the app is available for downloading.',

  SAVE_RELATION: 'Save relation',
  MAKE_ROUTE: 'Make route',

  TITLE: 'Title',
  TEXT: 'Text',
  DESTINATION: 'Destination',
  ACCOUNT_PREFERENCES_SAVED_CORRECTLY:
    'Account preferences are saved correctly!',
  PARTNER_PREFERENCES_SAVED_CORRECTLY:
    'Partner preferences are saved correctly!',
  ACCOUNT_ALREADY_ACTIVATED: 'Your account is already Activated!',
  LOCATION_CREATION_OK: 'Location created successfully',
  LOCATION_EDITING_OK: 'Location edited successfully',
  USERGROUP_INFO_SAVED_OK: 'UserGroup info saved successfully',
  ACCOUNT_SAVED_OK: 'Account saved successfully',
  USERGROUP: 'User group',
  DELETE_USERGROUP_TITLE: 'Are you sure to delete the Usergroup?',
  ACCOUNT_MNG: 'Account Management',
  CREATE: 'Create',
  SEND: 'Send',
  SAVE: 'Save',
  DELETE: 'Delete',
  SAVE_TOOLTIP: 'Save changes',
  SEND_VIP_CODE: 'Send VIP code',
  SEND_USERGROUP_CODE: 'Send code',

  ONCE_ONLY_NOTIFICATION: 'Only-once notification',
  CREATE_NEW_NOTIFICATION: 'Create new notification',
  LOCATION_NOTIFICATION: 'Location notifications',
  ALL_NOTIFICATION: 'All notifications',
  EDIT_NOTIFICATION: 'Edit notification',

  CONFIRM_REGISTER: 'Registration confirmed',

  NO_ACCOUNT_ID:
    'There is no account id specified in the URL or the account does not exist for this account',
  NO_PARTNER_ID:
    'The partner id is invalid or not specified in the URL. Please enter a valid partner id.',
  ACCOUNT_NAME: 'Account name',
  ACCOUNT_DESCRIPTION: 'Account description',
  LOCATION_OVERVIEW: 'Locations Overview',
  EVENT_OVERVIEW: 'Events Overview',
  STATISTICS: 'Statistics',
  LOCATIONS: 'Locations',
  CREATE_TOUR: 'Create tour',
  CONFIGURE_ROUTE: 'Configure route',
  SHOW_ROUTE: 'Show route',
  SHOW_WAYPOINTS: 'Show waypoints',
  ACCOUNT_TITLE: 'Account',
  DASHBOARD_TITLE: 'Dashboard',
  ACCOUNT_URL: 'Website URL',
  ACCOUNT_EMAIL: 'Email address administrator',
  ACCOUNT_TITLE_AUTOCOMPLETE: 'Name organisation',
  ACCOUNT_TITLE_CREATE_STYLE: 'Create your own style',
  ACCOUNT_URL_AUTOCOMPLETE: 'Website URL',
  ACCOUNT_EMAIL_AUTOCOMPLETE: 'Email address administrator',
  ACCOUNT_CONFIRMATION: 'Account confirmation',
  ACCOUNT_SELECTION_CONFIRMATION:
    'Are you sure you want to confirm your account with these data?',
  ACCOUNT_CHANGES_LATER: 'You can still change it later',
  ACCOUNT_LINK: 'Link',
  ACCOUNT_MAIN_LOCATION: 'Main location',
  ACCOUNT_ADMIN_NUMBER_SALE: 'Administration number sale',
  ACCOUNT_ADMIN_NUMBER_FEE: 'Administration number fee',
  ACCOUNT_SERVICE_PERCENTAGE: 'Service percentage',
  ACCOUNT_MAX_PREBOOKS: 'Max Prebooks',
  ACCOUNT_HIGH_VAT: 'High VAT',
  ACCOUNT_LOW_VAT: 'Low VAT',
  'ACCOUNT_SALES_&_FEES': 'Sales & Fees settings for',
  ACCOUNT_BOOKNUMBER_FEE: 'Booknumber Fees',
  ACCOUNT_JOURNAL_NUMBER_SALES: 'Journal number Sales',
  ACCOUNT_JOURNAL_NUMBER_FEES: 'Journal number Fees',
  ACCOUNT_NAME_OF_FILE: 'Name of file',
  ACCOUNT_MONTHLY_FEE_GENERATION_DAY: 'Monthly fee generation day',
  ACCOUNT_GENERATION_DAY: 'Generation day',
  ACCOUNT_SAVE_SALES_FEE:
    'Please save the sales & fees settings first, before you click on each of the buttons below.',
  ACCOUNT_BOTH_BUTTONS: 'Both buttons will be called on account',
  ACCOUNT_GENERATE_SALES_FEES: 'Generate Sales Fees',
  ACCOUNT_GENERATE_MONTHLY_FEES: 'Generate Monthly Fees',
  ACCOUNT_USERGROUP_NAME: 'Usergroup name',
  ACCOUNT_NEW_USERGROUP: 'New usergroup',
  ACCOUNT_EDIT_USERGROUP: 'Edit usergroup',
  ACCOUNT_USER_ID: 'User ID',
  ACCOUNT_DELETE_USER: 'Are you sure you want to delete the user',
  ACCOUNT_VAT_NUMBER: 'VAT number',
  ACCOUNT_VAT_BTW: 'Partner VAT number (BTW)',
  ACCOUNT_CAMPAIGN_BUDGET: 'Campaign Budget',
  ACCOUNT_PARTNER_SUPPLIER_CODE: 'Partner Supplier Code',
  ACCOUNT_SUPPLIER_CODE: 'Supplier code',
  // Tool Bar
  FINANCIAL_MANAGEMENT: 'Financial Management',
  FINANCIAL: 'Financial',
  THEME_LIST: 'Homepage',
  THEMES: 'Highlights',

  // home
  REGISTER: 'Register',
  REGISTER_HEAD: "Don't miss a thing",
  WHY_REGISTER: `Why register for ${appConfig.dss.environmentName}-app?`,
  REGISTER_LIST: `Enjoy the ${appConfig.dss.environmentName} to the fullest with these benefits for app users only.`,
  REGISTER_CONFIRMATION_EMAIL:
    "We've sent you a confirmation email with a link to activate your account.",
  REGISTER_SPAM_WARNING:
    "Check your spam folder in case you didn't receive the confirmation email.",
  REGISTER_LIST_1: 'We’ll keep you informed about your favorite events.',
  REGISTER_LIST_2: 'Win great prizes.',
  REGISTER_LIST_3: 'Purchase your parking ticket online.',
  REGISTER_LIST_4: 'Receive special offers and discounts.',
  REGISTER_LIST_5: 'Easily find your way with the handy map.  ',
  REGISTER_LIST_6: `Register for an account and download the ${appConfig.dss.environmentName} in the Apple App Store or Google Play.`,
  REGISTER_NOW: 'Register now',

  // register
  REGISTER_DETAILS: 'Create an account',
  REGISTER_DETAILS_INFO:
    'Please provide us with a few personal details so we can create an account for you',
  REGISTER_INFO: 'Why do we ask for this information?',
  REGISTER_PHONE: 'Mobile phone number: ',
  REGISTER_PHONE_TEXT:
    'we will keep you informed with text messages if there is a problem with the app.',
  REGISTER_VIP: 'Special Code',
  REGISTER_VIP_TEXT: `Did you receive a code from the ${appConfig.dss.environmentName} organization? Please enter it here. Otherwise please leave the field empty. `,
  REGISTER_ZIPCODE: 'Postal code: ',
  REGISTER_ZIPCODE_TEXT:
    'used to gain insight where our visitors come from, so we can attract more sponsors and keep the event free of charge for visitors. ',
  REGISTER_LICENSE: 'License Plate: ',
  REGISTER_LICENSE_TEXT:
    'if you travel by car, enter your license plate for fast access to the parking lot. ',
  REGISTER_CHECKBOX: 'I agree with the',
  REGISTER_PRIVACY_STATEMENT: 'Privacy statement',
  AGREE_PRIVACY_STATEMENT: 'By creating an account, you agree to our',
  REGISTER_KEEP_ME_UP_TO_DATE: `Yes, please keep me informed about the ${appConfig.dss.environmentName}`,
  REGISTER_FORM_NAME: 'Name',
  REGISTER_FORM_LASTNAME: 'Surname',
  REGISTER_FORM_EMAIL: 'E-mail',
  REGISTER_FORM_PHONE: 'Mobile phone number',
  REGISTER_FORM_ZIP: 'Postal code',
  REGISTER_FORM_COUNTRY: 'Choose a country',
  REGISTER_FORM_VIP: 'Special Code',
  REGISTER_FORM_LICENSE: 'License plate',
  REGISTER_ACCOUNT: 'Register an account',
  REGISTER_INTEREST_TITLE: 'Interests',
  REGISTER_INTEREST:
    'Let uw know what you’re interested in, so we can provide you with upcoming events that match your interests',
  REGISTER_ACCOMPANY:
    'Let us know who will accompany you, so we can help you pick suitable events.',
  REGISTER_ACCOMPANY_TITLE: 'I will visit with',
  REGISTER_ACCOUNT_EXIST:
    'Account exists. You can login with your PG_NAME account.',
  REGISTER_ACCOUNT_EXIST_CURR_PG:
    'Account exists. You can login directly or reset your password if you forgot it.',
  REGISTER_ACCOUNT_NOT_ACTIVATED:
    'Account created but not yet activated. Go to your mailbox to activate your account.',
  REGISTER_ACCOUNT_RESEND_ACTIVATION_EMAIL:
    "Didn't receive the activation email? Click the button below to resend the email.",
  RESEND_ACTIVATION_MAIL_SUCCESS_TITLE:
    'The activation email has been sent to your mailbox. Check your email and activate your account.',
  GENERATE_PASS: 'Generate password',

  GRAPH_0_LABEL_0: 'Arrived',
  GRAPH_0_LABEL_1: 'Expected',
  GRAPH_0: 'Bezoekers',
  GRAPH_0_OPT: 'Bezoekers',
  GRAPH_N_ARRIVALS: 'Number of arrivals',
  GRAPH_N_ARRIVALS_OPT: 'Optimized number of arrivals',
  GRAPH_N_DEPARTURE_OPT: 'Optimized number of departure',
  GRAPH_N_DEPARTURE: 'Number of departure',

  GRAPH_0: 'Total',
  GRAPH_1: 'Fixed',
  GRAPH_2: 'Flex',
  GRAPH_3: 'Slack',
  GRAPH_4: 'Queue length',
  GRAPH_5: 'Current',

  ERROR_EVENT2_01: 'arrivals exceed the capacity of this event',
  ERROR_EVENT2_02: 'queue length or waiting time exceeds the threshold',

  ERROR_DESTINATION_01: 'Database connection error',
  ERROR_DESTINATION_02: 'PushNotificationBridge connection error',
  ERROR_DESTINATION_03: 'Reschedule event in the past (not possible)',
  ERROR_DESTINATION_04:
    'Inconsistent event data (time window where endTime <= startTime)',
  ERROR_DESTINATION_05:
    'Max capacity exceeded (when trying to reschedule an event)',
  ERROR_DESTINATION_06:
    'No reward configured (when finalizing an event or triggering a negotiation round)',
  ERROR_DESTINATION_07: 'End time - startime bigger than the interval duration',
  ERROR_DESTINATION_08: 'Parent object is not of type destination',
  ERROR_DESTINATION_09: 'Parent object null',
  ERROR_DESTINATION_10: 'Current objecy null',
  ERROR_DESTINATION_11: 'Event set back in the past',
  ERROR_DIT_01:
    'No reward configured (when finalizing an event or triggering a negotiation round)',
  ERROR_DIS_01:
    'No reward configured (when finalizing an event or triggering a negotiation round)',
  ERROR_DIT_02: 'Dit thread is already running',
  ERROR_EVENT_01: 'Passed event id passed not correct',
  ERROR_EVENT_02: 'Passed slot id not correct',

  REGISTER_VISIT_WITH: `I will visit ${appConfig.dss.environmentName} with`,
  REGISTER_MYSELF: 'Myself',
  REGISTER_PARTNER: 'My Partner',
  REGISTER_FRIENDS: 'Friends',
  REGISTER_KIDS: 'Kids',
  REGISTER_SCHOOL: 'School',

  SUCCES_REGISTER: 'Yippee! Your account has been created',
  SUCCES_REGISTER_TEXT_1:
    'An email has been sent to you with a link to activate your account',
  SUCCES_REGISTER_TEXT_2:
    'Here’s your unique user-id. Use it to activate the app after downloading it in the Apple App Store or Google Play. You’ll also receive your user-id in your email with instructions on how to activate the app.   ',
  SUCCES_REGISTER_USER_ID: 'Your user-id: ',
  DOWNLOAD: 'Download the app',
  APPLE: 'for Apple',
  ANDROID: 'for Android',

  APPLY: 'Apply',

  TAGS: 'Tags',
  TAGS_EVENT: 'Select your favorite tags',
  TAGS_TEXT:
    'Please select the tags you like, so we can show you events related to this tags.',
  TAGS_REQ: 'Please select the tags',

  // Tickets
  TICKET_NEW: 'New ticket type',
  TICKETS_PRICING_EXPLANATION:
    'Because the pricing is externally managed, there is no possibility to add ticket',
  TICKET_SOME_EXPLANATION: 'Some explanation about ticket types',
  TICKET: 'Tickets',
  TICKET_EVENT: 'Select your favorite events',
  TICKET_TEXT:
    'Please select the days you will be visiting us, so we can keep you informed about your favorite events. You can also immediately purchase tickets for paid events. ',
  TICKET_WARNING: 'Please note',
  TICKET_TEXT_1:
    ' that parking is paid on Saturday June 30th. Purchase your ticket online by selecting “Parking” on the right. An online ticket will allow you to skip the line and avoid the hassle of paying in cash.',
  TICKET_TEXT_2:
    'that purchased tickets are non refundable and non transferable. You will receive your tickets by email within 30 minutes after completing the payment process.',
  TICKET_TEXT_3: 'By purchasing your tickets online you agree to our ',
  TICKET_TEXT_TERMS: 'general terms.',
  TICKET_ATTEND: 'Which days do you want to attend?',
  TICKET_ARRIVING: 'What time will you be arriving?',
  TICKET_INFORMATION: 'Tickets are handled by the event organization.',
  TICKET_INFORMATION2: 'An entrance fee may be charged at the location.',

  // Linda output
  TRIPS: 'Trips',
  TRIP_WELCOME: 'Welcome to your triplist',
  TRIP_CHOICE:
    'Please select a trip in your specialised triplist to show it or delete it. If there is no trip in your triplist, you can create a trip for this event by clicking on the "+" icon in the top right corner.',
  TRIP_STARTED: 'Lets personalise your trip ',
  TRIP_EVENT_PICKER:
    'Please make a choice out of the following events to visit. if you want to add another day on the same event or a new trip, it is possible after the completion of this event registration!',
  TRIP_DATEPICKER:
    'Now that you know what event you will be visiting, lets choose the right date to visit the event. Please click on the date you want to visit the event.',
  TRIP_PLAN: 'Plan my trip',

  PAYMENT: 'Please confirm your choices ',
  PAYMENT_TEXT:
    'Please check the following data and confirm your choices to complete your ticket registration.',
  PAYMENT_CONFIRM: 'Confirm',
  PAYMENT_CONFIRM_PAY: 'Confirm and pay',
  PAYMENT_OVERVIEW: 'Overview of events:',
  ARRIVAL_INFO: 'Selected event days: ',
  ARRIVAL_TIME: 'Expected arrival time: ',
  TOTAL_PRICE: 'Total price:',

  TICKET_SUCCES: 'Hurray! We’re looking forward to welcoming you.',
  // 'TICKET_SUCCES_1': 'Your registration is successful. We’ll send you a confirmation by email.',
  TICKET_SUCCES_1: `Your registration is successful. Good luck and enjoy The ${appConfig.dss.environmentName} !`,
  TICKET_SUCCES_2: `Now it’s time to download and activate the app to have a chance at those nice prizes. Good luck and enjoy The ${appConfig.dss.environmentName} !`,

  TICKET_ORDER: 'Order tickets',
  TICKET_ORDER_1: 'Confirm your order',
  TICKET_ORDER_2: '',
  EVENT_PAYMENT: 'Payment process',
  EVENT_PAYMENT_INFO:
    'You will be redirected to Mollie payments to complete your payment process',
  EVENT_PAYMENT_INFO_1: '',
  TRIP_TICKETS: 'Download tickets',

  PAYMENT_SUCCESS: 'Payment succeeded',
  PAYMENT_FAILED: 'Payment failed',
  TO_APP_USERS:
    'If you are an app user, please return back to the app to continue!',

  TICKET_UNSUCCESSFUL:
    'Oops! We’re very sorry but your payment was unsuccessful',
  TICKET_UNSUCCESSFUL_TEXT:
    'Please try again, we’re sure it’s just a glitch. If you keep encountering this issue, please contact The Driving Force customer service center at customerservice@thedrivingforce.nl or call +31 297 51 44 55. ',
  RETRY: 'Retry',

  SUCCES_PAYMENT: 'Hurray! Your payment was successful.',
  SUCCES_PAYMENT_1:
    'Your registration is now completed. We’ll send you a confirmation by email with your tickets. We’re looking forward to welcoming you.',
  SUCCES_PAYMENT_2: `Now it’s time to download and activate the app to have a chance at those nice prizes. Good luck and enjoy The ${appConfig.dss.environmentName}. `,
  Website_Down_1:
    'We are very Sorry but the Webite is temporarily unavailable.',
  Website_Down_2: 'We are Working on it and it will be back very soon.',

  DRIP_OBJECT_NAME: 'Name DRIP',
  DRIP_OBJECT_DESCRIPTION: 'Description of DRIP',
  DRIP_LOCATION: 'Right click op de kaart voor de locatie van de DRIP',
  DRIP_IPADDRESS: 'IP adres of DRIP',
  DRIP_PORT: 'Port number of DRIP',
  DRIP_WINDOWNAME: 'Window name of DRIP',
  DRIP_HEIGHT: 'Height of DRIP',
  DRIP_BREADTH: 'Width of DRIP',

  PRIS_OBJECT_NAME: 'Name of PRIS',
  PRIS_OBJECT_DESCRIPTION: 'Description of PRIS',
  PRIS_LOCATION: 'Right click op de kaart voor de locatie van de PRIS',
  PRIS_IPADDRESS: 'IP adres of PRIS',
  PRIS_PORT: 'Port number of PRIS',
  PRIS_WINDOWNAME: 'Window name of PRIS',
  PRIS_HEIGHT: 'Height of PRIS',
  PRIS_BREADTH: 'Width of PRIS',

  VRI_OBJECT_NAME: 'Name of PRIS',
  VRI_OBJECT_DESCRIPTION: 'Description of PRIS',
  VRI_WEBSITE: 'Website',
  VRI_IP: 'IP adres',
  VRI_IVERA: 'Ivera',
  VRI_IVERA_NAME: 'Ivera name',
  VRI_PASSWORD: 'Ivera password',
  VRI_ITS: 'ITS Name',
  VRI_ITS_PASSWORD: 'ITS password',
  VRI_TRIGGER_CERT: 'Trigger certificate',
  VRI_CERT: 'VRI certificate',
  VRI_TRIGGER_IP: 'Trigger ip',
  VRI_VTYPE: 'V type',
  VRI_VVERSION: 'V Version',
  VRI_VNAME: 'V name',
  VRI_VPASSWORD: 'V password',
  VRI_VSOURCE: 'V Source',
  VRI_VIP: 'VIP',
  VRI_VPORT: 'V Port',
  VRI_CAPACITY: 'Capacity',
  VRI_NOTES: 'Notes',
  VRI_CONFIG: 'Configuere',
  VRI_XY: 'XY',
  VRI_KPP: 'KPP',
  VRI_ATTACHMENT: 'Attchements',

  NO_RELATION: 'No relations',
  NO_TRAFFIC_OBJECTS: 'No trafficobjects',
  NO_SENSOR_ACTUATOR: 'No Sensor actuators',
  NO_EVENTS: 'No events',
  NO_EVENTS_AVAILABLE: 'No events available',
  AVAILABLE: 'Available',
  ADD_RELATION: 'Add relation',
  ADD_INCIDENT: 'Add indcident',
  ADD_TRAFFIC_OBJECT: 'Add trafficobject',
  ADD_SENSOR_ACTUATOR: 'Add sensor actuator',
  ADD_EVENTS: 'Add event',
  NO_ENTRY_EXIT_POINTS: 'No entry/exit points',
  ENTRY_EXIT_POINTS: 'Entry and exit points',
  INCIDENTS: 'Incidents',
  RELATIONS: 'Relations',
  TRAFFIC_OBJECTS: 'Trafficobject',
  SENSOR_ACTUATOR: 'Sensor / actuators',
  EVENTS: 'Events',
  SAVE_RELATION: 'Save relation',
  MAKE_ROUTE: 'Make route',

  OP_SCREEN: 'Operational screens',
  MAP_TITLE: 'Map',
  ROUTE_MAP_TITLE: 'Route Map',
  ROUTE_MAP_DESC:
    'Click on the map to enter the route editor. Within the route editor you can adjust the route, add stops to your route and more.',
  TRAVEL_MODE: 'Travel mode',
  EVENT_START_PLANNING: 'Plan',
  ORDERS: 'Orders',
  EVENT_START_SIMULATE: 'Simulate',
  FILTER_OPTIONS: 'Filter options',

  INVALID_ENDDATE: 'The end date is before the start date.',
  INVALID_ENDTIME: 'The departure time is before the arrival time.',
  INVALID_INPUT: 'The input fields are incorrect filled in.',
  INVALID_WEBSITE: 'Invalid website',
  INVALID_EMAIL: 'Invalid email address',
  FIELD_REQUIRED: 'Field is required',
  FIELD_MAX_LENGTH_32: 'Field length cannot exceed 32 chars long!',
  FIELD_MAX_LENGTH_1024: 'Field length cannot exceed 1024 chars long!',
  FIELD_MAX_LENGTH_64: 'Field length cannot exceed 64 chars long!',
  FIELD_MAX_LENGTH_45: 'Field length cannot exceed 45 chars long!',
  FIELD_MAX_LENGTH_128: 'Field length cannot exceed 128 chars long!',
  FIELD_NO_SPECIAL_CHARS: 'Special chars not admitted ,/"\'{}[]()#$%^&* |',

  DELETE_EVENT_NOK: 'You are not the owner of Event, you can not delete it!',
  DELETE_EVENT: 'Are you sure want to delete the event?',

  DELETE_USER: 'Delete user',
  TAGS_CATEGORIES: 'Categories',
  DELETE_FILTERS: 'Delete filters',

  // New > still to sort out
  DIRECT_BOOKING: 'Direct Bookings',
  ASPECTS: 'Aspects',
  NEW_ASPECT: 'New aspect',
  BRAND: 'Brand',
  COPY: 'copy',
  REQUIRED: 'Required',
  SORT: 'Sort',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  EDIT_TRANSLATIONS: 'Edit translations',
  EDIT_BATCHGROUPS: 'Edit batchgroups',
  maintenance:
    'Dear visitor, \n the website is currently under construction. We are working very hard to make the website even better! Please try again later. Sorry for the inconvenience.',
  CREATE_USER: 'Create account',
  START_TYPING: 'Start typing to Search',
  SQUARE_PER_PERSON: 'Square meter per person (in M2)',
  ACTIVITY: 'Activity',
  ADD_TO_CARD: 'Added to shopping cart',
  VIEW_ORDER: 'View order',
  UPDATE_YOUR_ACCOUNT: ' Do you want us to update your account?',
  UPDATE_USER: 'Update user',
  HOUSE_NUMBER: 'House number',
  SELECT_TIME: 'Select a time',
  INPUT_FIELDS_EMPTY: 'The input fields are empty.',
  NOTHING_FILLED_IN: 'Nothing filled in',
  RETURN_TO_MY_ACTIVITIES:
    "The order is saved. you will be returned to the 'My activities' page.",
  REDIRECT_TO_APPOINTMENTS:
    'You will be automatically redirected to your appointments',
  REDIRECT_TO_PAYMENT:
    'You will be automatically redirected to the payment page',
  ORDER_RECEIVED: 'Your order has been received.',
  ORDER_INFO: 'Order info ',
  ORDER_OVERVIEW: 'Order overview',
  ACTIVITY_PRICE: 'Activity Price:',
  ORDER_ID: 'Your order id:',
  YOUR_ORDER: 'Your order',
  FILL_PERSONAL_DETAILS: 'Fill your personal details in',
  CHOOSE_PRODUCTS: 'Choose your products',
  CHOOSE_DATE: 'Choose a date and time',
  CHOOSE_DELIVERY_PICKUP_METHOD: 'Choose pickup or shipping',
  PICKUP_LOCATIONS: 'Pick-up locations',
  MORE_INFO: 'More info',
  ARRIVAL: 'Arrival',
  ADD_ACCOMMODATION: ' Add accommodation',
  DAILY_ACTIVITIES: 'Your daily activities',
  DEPARTURE: 'Departure',
  GENERAL: 'General',
  ADDRESS: 'Address',
  POSTAL_CODE: 'Zip/Postal code',
  COMPANY_NAME: 'Company name',
  COMPANY_EMAIL: 'Company email',
  PREFERENCES: 'Preferences',
  CUSTOMERS: 'Customers',
  SEARCH: 'Search',
  ADD: 'Add',
  CREATE_USERGROUP: 'Create new user group',
  EDIT_USERGROUP: 'Edit usergroup',
  DELETE_USERGROUP: 'Delete usergroup',
  GROUP: 'Group',
  USERGROUPS: 'Usergroups',
  USERGROUP_NAME: 'Usergroup name',
  SEARCH_FAILED_FIRST_PART: 'Your search for ',
  SEARCH_FAILED_SECOND_PART: ' found no results.',
  BATCHGROUPS: 'Batchgroups',
  OPTIONS: 'Options',
  VIEW_BATCHGROUP: 'Viewing batchgroup',
  CREATE_BATCHGROUP: 'Creating a batchgroup',
  DAY_MON: 'Mon',
  DAY_TUE: 'Tue',
  DAY_WED: 'Wed',
  DAY_THU: 'Thu',
  DAY_FRI: 'Fri',
  DAY_SAT: 'Sat',
  DAY_SUN: 'Sun',
  SELECTED_DATES: 'Selected date(s)',
  START_END_DATE_EQUAL_ERROR:
    'The end date is equal to the start date, please change the end date to continue.',
  DETAILS: 'Details',
  OWNED_BY: 'Owned by',
  VISIBLE_FOR: 'Visible for',
  MAIN_EVENT: 'Main event',
  EVENT_DELETION: 'Event deletion',
  ADD_LANGUAGE_PLUS: '+ Add New Language',
  ADD_LANGUAGE: 'Add New Language',
  LANGUAGE: 'Language',
  DESCRIPTION: 'Description',
  ARRIVAL_TEXT_MSG: 'Arrival text message',
  DEPARTURE_TEXT_MSG: 'Departure text message',
  PREV_SCREEN: 'Go to previous screen',
  DONE: 'Done',
  ADD_CHOICE: 'Add choice',
  CLOSE_EDIT_WINDOW: 'Close edit window',
  WARNING: 'Warning',
  UNSAVED_CHANGES:
    'You still have unsaved changes! Are you sure you want to undo the changes.',
  EVENT_DETAILS: 'Event details',
  EVENT_INFO: 'Info',
  MESSAGE_DELETION: 'Message deletion',
  PLAY_AUDIO: 'Play audio',
  DELETE_AUDIO: 'Delete audio',
  UPLOAD_EVENT_PIC: 'Upload a event picture',
  DELETE_LOGO: 'Delete logo',
  RESULT: 'Result',
  IMAGE: 'Image',
  GO: 'Go',
  SEARCH_OSM: 'Search in OpenStreetMap',
  STREET: 'Street',
  CITY: 'City',
  COUNTRY: 'Country',
  TELEPHONE: 'Telephone',
  OPENING_HOURS: 'Opening hours (Mo - Fr 08:00 - 17:30)',
  TRANSPORTATION: 'Transportation',
  OK: 'Ok',
  MY_APPOINTMENTS: 'My activities',
  INPUT_RELATION_NAME: 'Input relation name',
  MAKE_ROUTE: 'Make route',
  SAVE_RELATION: 'Save relation',
  MIN_GROUPSIZE: 'The group size must be at least 1',
  NO_VALID_TIME_INPUT: 'Time input is not valid, please enter a valid time.',
  EVENT_EDITING: 'Edit event',
  DELETING_EVENT: 'Delete event',
  NEW_EVENT: 'New event',
  EDITING: 'Editing ',
  LOCATION: 'Location',
  EVENT_CAPACITY: 'Maximum capacity in persons',
  LEAD_TIME: 'Lead time',
  COOLDOWN_TIME: 'Cool down time',
  DURATION: 'Duration',
  SELECT_SUBACTIVITIES: 'Select subactivities',
  SELECTED_SUBACTIVITIES: 'Selected subactivities',
  EVENT_PICTURE: 'Event picture',
  CATEGORIES: 'Categories',
  SALE: 'SALE',
  AVAILABLE_OTHER_ACCOUNTS: 'Available for other accounts',
  VISIBILITY: 'Visibility',
  ALL_EVENTS: 'All events',
  NO_EVENT_AVAILABLE: 'No events available',
  NAME: 'Name',
  UPLOAD_IMAGE: 'Upload image',
  USER_NOT_LOGGED_IN_TO_RETRIEVE_PAYMENTS:
    'Unfortunately you are not logged in to retrieve payments information. Please log in and retry!',
  GROUP_SIZE: 'Group size',
  QUANTITY: 'Quantity',
  TOTAL: 'Total',
  SUBTOTAL: 'Subtotal',
  ADD_TAGS: 'Add tags',
  TOTAL_INCIDENTS: 'Total incidents',
  ADD_INCIDENT: 'Add incident',
  VIEW_DETAILS: 'View details',
  SAVE_INCIDENT: 'Save incident',
  SAVE_IMAGE: 'Save image',
  ADD_LOCATION: 'Add location',
  ADD_A_LOCATION: 'Add a location',
  EDIT_LOCATION: 'Edit location',
  DEL_LOCATION: 'Delete location',
  LINK_ACTIVATE_ACCOUNT: 'Open the link in the mail to activate your account.',
  WRONG_TIME_INPUT: 'Time input is not valid, please enter a valid time.',
  MESSAGE_TITLE_TEXT: 'Please enter the message title and text to continue',
  ERROR_MSG_NO_PLACE_SUB_EVENT:
    'There is no place available for a chosen sub event(s): ',
  ERROR_MSG_INVALID_TIME: 'Invalid input of time',
  ERROR_MSG_INVALID_DATE: 'Invalid input of date',
  ERROR_MSG_NO_ENTRY_TRANSPORT:
    'There are no available entry points left for this type of transport',
  ERROR_MSG_EVENTS_RESET: 'Your events have been reset, please reselect them.',
  ERROR_MSG_ARRIVAL_DEPARTURE: 'Please change the arrival or departure time.',
  WARNING_MSG_EARLY: 'Are you sure you want to arrivate at ',
  MAIN_EVENT_START: 'The main event will start at ',
  ERROR_MSG_NO_PLACE_MAIN_EVENT:
    'There is no place available for the main event: ',
  ERROR_MSG_NO_PLACE_TRANSPORT_MODE:
    'There are no available spaces left for the chosen mode of transport',
  ERROR_MSG_NO_MAIN_BATCH_CHOSEN_TIME:
    'No main batch in the time range, please select a different time range',
  SELECT_TRIP_DAY: 'Please select the day to view your trip list',
  ENTER_SPECIAL_CODE: 'Enter special code',
  WRONG_INPUT: 'Wrong input',
  INPUT_NOT_COMPLETE: 'Your input is not complete or right',
  VALID_VIP_CODE: 'Please enter a valid VIP code',
  MY_EVENTS: 'My events',
  PART_OF: 'Part of',
  SELECTION_OF_USERS: 'Selection of users',
  CRITERIA_BOTH: 'Registered & non-registered users',
  CRITERIA_REG: 'Registered users',
  CRITERIA_NOT_REG: 'Non-registered users ',
  UG_FOR_USER: 'Available usergroups',
  SELECTED_UG_FOR_USER: 'User is already registered for: ',
  WEB_BROWSER_VERSION: 'Chrome browser version',
  UPDATE_BROWSER_DETECTION:
    'The system detected that the version of the chrome browser you are working on is not up-to-date.',
  UPDATE_BROWSER_FAILS:
    'Because of this, some functionalities could not work properly.',
  UPDATE_BROWSER: 'Please update your chrome browser to the latest version.',
  CALENDAR: 'Whats on',
  ONLY: 'Only',
  FREE_PLACES: 'places available',
  MINUTES: 'minutes',
  BOOK: 'Book',
  LOCATION_PICTURE: 'Location picture',
  UPLOAD_LOCATION_PIC: 'Upload a location picture',
  TOGGLE_MAP: 'Toggle map',
  TOGGLE_ACTIVITYLIST: 'Show daily activities',

  // Partner
  PARTNER_LEVEL: 'Partner level',
  PARTNER_SELECT: 'Select a partner',
  PARTNERS: 'Partners',
  PARTNER_DETAILS: 'Partner details',
  DELETE_PARTNER_TITLE: 'Are you sure to delete the Partner?',
  PARTNER_NAME: 'Partner name',
  PARTNER_ADDRESS: 'Partner address',
  PARTNER_CITY: 'Partner city',
  PARTNER_EMAIL: 'Partner email',
  PARTNER_POSTAL_CODE: 'Partner postal code',
  PARTNER_IBAN: 'Partner IBAN',
  PARTNER_TYPE: 'Partner type',
  SERVICE_PRICE: 'Service price',
  SERVICE_PRICE_PERCENTAGE: 'Service price percentage',
  SERVICE_MINIMUM_PRICE: 'Minimum service price',
  PLANNING_CONTRACT: 'Planning contract',
  PAYMENT_CONTRACT: 'Payment contract',
  PAYMENT_PLATFORM: 'Payment platform',
  CREATE_PARTNER: 'Create partner',
  TERMS_ACCEPT: 'I accept the',
  DIRECT_DEBIT: 'I accept direct debit',
  ACTIVE_PARTNER: 'Activate partner',
  MIN_MONTHLY_FEE: 'Minimum monthly fee',

  // Empty slots
  EMPTY_SLOTS_TITLE: 'Are you sure to empty these slots?',

  // Suggestions
  SUGGESTIONS_SELECTED: 'Selected suggestions',
  SUGGESTIONS_SELECT: 'Select suggestions',
  SUGGESTIONS: 'Suggestions',
  SUGGESTIONS_NO_PLACES:
    "The suggestions doesn't have places left. You can choose another suggestion.",
  SUGGESTION_BOOK_FAILED: 'Book suggestion not possible',
  NO_SUGGESTIONS_FOUND: 'No suggestions found',
  NO_SUGGESTIONS: "There aren't suggestions found",
  NO_CAPACITY: 'No capacity',
  LIST_OF_SUGGESTIONS: 'List of the suggestions',
  ADD_SUGGESTION: 'Add suggestion',
  ADD_SUGGESTION_ACCEPT:
    'Are you sure you want to add this suggestion to your order?',
  CANCEL_YOUR_ORDER: 'Cancel order',
  CANCEL_YOUR_ORDER_ACCEPT: 'Are you sure you want to cancel your order?',
  REMOVE_SUGGESTION: 'Remove suggestion',
  REMOVE_SUGGESTION_ACCEPT: 'Are you sure you want to remove this suggestion?',
  NO_IM_NOT: "No I'm not",
  YES_I_AM: 'Yes I am',
  SUGGESTION_MAKE_CHOICE: 'Make a choice',
  SUGGESTION_DRINKING: 'I want something to drink',
  SUGGESTION_EATING: 'I want something to eat',
  SUGGESTIONS_CLICK_HERE: 'Click here',
  ORDER_ALL_PRODUCT_SUGGESTIONS: 'Add all products',
  FAILED_PRODUCTS_CAPACITY_ERROR:
    'Product(s) below are out of stock and not added to your shopping cart',
  FAILED_PRODUCTS_ALREADY_IN_CART:
    'Product(s) below are already in your shopping cart and not added again',
  ORDER_ALL_PRODUCT_SUGGESTIONS_FAILED:
    'Failed to add products to your shopping cart. Please try again later.',
  JOIN_QUIZ: 'Join',

  // Calendar
  CALENDAR_EVENT_STARTTIME: 'Start time',
  CALENDAR_EVENT_ENDTIME: 'End time',
  CALANDER_NAME: 'Calendar',
  CALENDAR_NO_ITEMS: 'There are no calendar items for the selected days.',

  // Statistics
  GET_STATISTICS: 'Get statistics',
  STATISTICS_OF_TRIPS: 'Statistics of Trips',
  STATISTICS_OF_SUGGESTIONS: 'Statistics of Suggestions',
  STATISTICS_OF_DIRECT_BOOKING: 'Statistics of Direct Bookings',
  STATISTICS_OF_PARTNERS: 'Statistics of Partners',
  STATISTICS_OF_USERS: 'Statistics of Users',
  STATISTICS_SELECT_THE_DATES: 'Select the dates',
  STATISTICS_SELECT_THE_PARTNER: 'Select the partner',

  // Activity details screen
  CHOOSE_A_LOCATION: 'Choose a location',
  CHOICES: 'Choices',
  READ_MORE: 'Read more',
  READ_LESS: 'Read less',
  DELIVERY_FEE: 'Delivery fee',
  OPTIONS_EXTRA_FEE: 'Extra costs for chosen options',
  MORE_PRODUCTS: 'more products',
  OR_ORDER_FOR: 'Or order for',
  SELECT_THIS: 'If you select this one you have to pay',
  CONFIRM_YOUR_CHOICES: 'Confirm your choices',
  CONFIRM_YOUR_CHOICES_EXPLANATION: 'Review your choices and press complete.',
  PERSONAL_DETAILS_EXPLANATION:
    'Enter the necessary personal details and leave a comment for special requests if desired.',
  ENTER_YOUR_PERSONAL_DETAILS: 'Enter your personal details',
  CHOOSE_AN_OPTION: 'Additional costs and options',
  CLICK_TO_OPEN: 'Click to open',
  STARTING_AT: 'Starting at',
  AND: 'and',
  SHOWING_OPTION:
    'Indicate the number of persons of the desired option or ticket.',
  SELECTED_DATA_EXPLANATION:
    'Choose a date or period and a start and end time when applicable.',
  PRODUCT_BELOW_EXPLANATION:
    'Below you will find the products. Add the products you want and then press order now.',
  BOOKING_FLOW_EXPLANATION:
    'You are now in the booking process fill in the following fields to continue.',
  EXPLAINING_COLOR_CHIPS:
    'The colors below indicate how busy it is in certain timeslots',
  NO_PRODUCTS: 'There are no products in your shopping cart',
  NO_DAYS_AVAILABLE: 'No days available',
  NO_BOOKINGS_YET: 'Nothing has been booked yet',
  PRE_EVENT_NOTIFICATIONS: 'Activate pre-event notifications',
  PRE_EVENT_NOTIFICATIONS_EXPLANATION:
    'When you select this, you receive a message a few minutes before the event starts.',
  NO_ENDTIMES:
    "Can't get end times with the chosen start time, please choose another start time.",
  CANT_FIND_STARTIME: "Can't find a start time with this start date",
  CANT_FIND_ENDDATE: "Can't find an end date with this start time",
  CANT_FIND_ENDTIME: "Can't find an end time with this end date",
  CHOSEN_DETAILS: 'Chosen details',
  STARTDATE: 'Start date',
  ENDDATE: 'End date',
  ACCEPT: 'Accept',
  AMOUNT: 'Amount',
  AMOUNT_OF_PRODUCTS: 'Quantity',
  AVA_DAYS: 'Available days',
  TIMES: 'Times',
  OPEN_HOURS: 'Opening hours',
  HOURS: 'hour',
  PRICE: 'Prices starting at',
  PRICE2: 'Price',
  CONTACT: 'Contact',
  PHONE_NR: 'Phone number',
  REQUEST_CLIENT1: 'Choose a time',
  REQUEST_CLIENT2: 'Please choose an amount of tickets.',
  OPENED_AT: 'Opened at',
  CLOSED_AT: 'Closed at',
  SAVE_DETAILS:
    'Save the personal details in my account for future reservations or orders',
  NO_PLACE: 'No place',
  NO_PLACE_BATCH: 'No place in this time slot please choose a different one',
  FREE_DELIVERY: 'Free delivery',
  FREE: 'Free',
  EX_DELIVERY_FEE: 'excl. delivery costs',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
  PRICE_PERCENTAGE: 'Price percentage',
  PRICE_OVERVIEW: 'Price overview',
  PERCENTAGE_EXPLANATION:
    'This percentage displays the percentage from the orignal price.',
  UNAVAILABLE: 'Unavailable items',
  ITEMS: 'Items',
  ADD_ITEMS: 'Add items',
  UNAVAILABLE_TEXT:
    "There are unavailable items. Do you accept that you can't buy these items.",
  PLEASE_STARTDATE: 'Please choose a start date',
  PLEASE_ENDDATE: 'Please choose an end date',
  PLEASE_STARTTIME: 'Please choose a start time',
  PLEASE_ENDTIME: 'Please choose an end time',
  CROWDED: 'Crowded',
  UNCROWDED: 'Uncrowded',
  NORMAL: 'Normal',
  BOOKED: 'Booked',
  OUT_OF_STOCK: 'This product is out of stock',
  AVAILABLE_PRICES: 'Available prices',
  PRODUCT_INFO: 'Product information',
  PRICE_STARTING_AT: 'Price starting at',
  NOT_AVAILABLE: 'Not available',
  COMBINATION_NOT_AVAILABLE:
    'A product with the selected options is not available.',
  ALMOST_FULL: 'Almost full',
  NOT_BUSY: 'Not busy',
  SELECT_ORDERTYPE: 'Please select the type of order',
  REMARK: 'Comments',
  REMARK_OPTIONAL: 'Comments (optional)',
  DELIVERY_DISTANCE: 'Delivery distance',

  REGISTER_PAGE_TEXT:
    'To create your personal accountName passport, we only need your email address. Your email address will also be used to send you booking confirmations and tickets when you book activities. ',
  REGISTER_EMAIL_USAGE:
    'Create an account to order quickly and easily, save for great discounts and easily repeat orders.',
  REGISTER_PAGE_WELCOME:
    'To create your account, we only need your email address. Your email address will also be used to send you booking confirmations and tickets when you book activities. ',
  LOGIN_PERSONAL:
    'Please login to your personal accountName passport. Don’t have a passport yet? Register to create one in just one minute. With your accountName passport you can easily plan and book your visit to accountName, save your favourite activities and get discounts for your visit to accountName. ',

  // Coupon code order
  DETAILS_FROM_RECIPIENT: 'Gift voucher recipient details',
  RECIPIENT_MESSAGE: 'Message for the recipient',
  RECIPIENT_FIRSTNAME: "Recipient's first name",
  RECIPIENT_LASTNAME: "Recipient's last name",
  RECIPIENT_EMAIL: "Recipient's email",
  RECIPIENT_DETAILS_DESCRIPTION:
    'If you want to send the coupon directly to the recipient, you can enter his or her details here.<br>If you want to receive the coupon yourself, you can leave the fields empty.<br>You will also receive a copy of the coupon code yourself.',

  // orders
  ORDER: 'Select event',
  ORDER_LIST_EMPTY: 'List is empty',
  ORDER_NO_ORDERS: 'No orders',
  ORDER_NO_ORDERS_FOUND: 'There are no orders found',
  ORDER_DOWNLOAD: 'Download',
  ORDER_NOW: 'Order now',
  ORDER_TYPE: 'Order type',
  ORDER_NR: 'Order nr',
  ORDER_DETAILS: 'Order details',
  NOTHING_DROPPED: 'Nothing dropped',
  DROPPED: 'Dropped',
  ORDER_COMPLETED: 'Order completed',
  ORDER_COMPLETED_DEFAULT:
    'Thank you for your order. Your order has been created successfully.',
  ORDER_COMPLETED_DEBIT: 'Your payment will be handled through direct debit.',
  ORDER_COMPLETED_INVOICE:
    'You will receive the invoice by Email. Please pay the invoice before the due date.',
  ORDER_THANKS: 'Thank you for your order.',
  ORDER_VIEW_BELOW:
    'You can view your activity by clicking on the button below.',
  ORDER_COUPON_CODE: 'Coupon code',
  ORDER_CHECK_COUPON_CODE: 'Check coupon code',
  COUPON_NOT_APPLIED_TITLE: 'Add your coupon code',
  COUPON_NOT_APPLIED_MESSAGE:
    'Coupon code is filled in but not yet added to your order. Do you want to add it now?',
  ORDER_WAIT_FOR_PARTNER_CONFIRMATION:
    'Your booking request has been forwarded to our partner for confirmation. You will receive a message when the partner has confirmed or rejected your booking request.',
  CANCEL_ORDER_GROUP_SUCCESS: 'Your order has been successfully cancelled.',
  CANCEL_ORDER_GROUP_ERROR:
    'Failed to cancel your order. Please try again later.',

  // Error codes
  E_00_00: 'Something went wrong, please try again later',
  E_PO_010:
    'The different slots for the activity where not available right now, please try again later',
  E_PO_011:
    'It was not possible to add an activity to the planboard, please check your planboard and try a different date or time.',
  E_PO_012:
    'It was not possible to add an activity to the planboard, please try again later',
  E_PO_013:
    'The chosen slot has no capacity, please try a different slot if available',
  E_PO_014:
    'It was not possible to change the chosen activity in your planboard',
  E_PO_015:
    "You are not allowed to edit this activity, because the status for payment is not 'paid'",
  E_PO_016:
    'The chosen time is in a different slots-group, please choose a different time',
  E_BK_001:
    'Unfortunately the chosen location of the event is too crowded, please try to change the arrival or departure time and try again. ',
  E_BK_002:
    "None of the products you've chosen are available, please choose a different time or product and continue.",
  E_PC_003:
    "You can't delete a Price Category that is already linked to a Time slot",
  E_CP_001: 'No arrival capacity available',
  E_CP_002: 'No departure capacity available',
  E_CP_003: 'No event capacity available',
  E_CP_004: 'Batch could not be found',
  E_CP_005: 'The product has no capacity',
  E_OB_002:
    'The chosen event was not able to retrieve his data, please try again later',
  E_UG_002: 'The order does not belong to the current partner',
  E_UG_003: 'The order has already been scanned',
  E_UG_004: 'The tickets within the order are not confirmed',

  E_ROUTE_001: 'No capacity',
  E_ROUTE_002: 'There were no orders in the database for the given input',
  E_ROUTE_003: 'Route generator has not found a solution within the given time',
  E_ROUTE_004: 'There is no solution to the given routing problem',
  E_ROUTE_005: 'Route generator not configured correctly',
  E_ROUTE_006: 'No route found, please try a different travel mode',
  E_GSD_001: 'There are no start dates',
  E_GSD_002: 'There are no end dates',
  E_GSD_003: 'There are no start times',
  E_GSD_004: 'There are no end dates',

  E_MPID_001: 'The payment-ID is missing',
  E_RA_001: 'Retrieving the event data failed, please try again later',
  E_RA_002: 'Retrieving the route aspect data failed, please try again later',
  E_RA_003:
    'The received route aspect data is not for the right event, please try again later',
  E_RA_004:
    'Retrieving the path-points within the route aspect data failed, please try again later',

  E_OM_001: 'The order-ID is incorrect.',
  E_OM_002: 'The confirmation-ID does not belong to the order-ID.',
  E_OM_003: 'The order has already been accepted/rejected.',

  // Back-End Failure
  W_BEF_001: 'The received data is incomplete, please try again later. ',
  W_BEF_002:
    'The server is currently offline, SuperLinda and her team are working very hard to solve it. ',

  // CouponCode
  E_GV_001: 'You have already used this coupon code.',
  E_GV_002: 'This coupon code is invalid.',
  E_GV_004: 'This coupon code can only be used by certain user classes.',
  E_GV_005: 'Invalid coupon code. The coupon has expired.',

  // GetAccountInfo
  W_GAI_001: 'The account data is incomplete, please try again. ',

  // GetUserData
  W_GUD_001: 'The user data is incomplete, please try again. ',
  W_GUD_002: 'we were not able to receive the user data, please try again. ',

  // GetEventDetails
  W_GED_001: 'Loading the picture failed, please try again. ',
  W_GED_002: 'Loading the description failed, please try again. ',
  W_GED_003: 'Loading the Event-id failed, please try again. ',
  W_GED_004: 'Loading the Event details failed, please try again. ',

  // GetCalendar
  W_GC_001: 'Loading the calendar failed, please try again. ',

  // GetTourActivities
  W_GTA_001: 'Retrieving the tour activities failed,please try again. ',

  // GetThemes
  W_GT_001:
    'Loading the themes for the current account failed, please try again. ',

  // GetChildrenEvents
  W_GCE_001:
    'Loading the events from the selected theme failed, please try again. ',

  // GetFavourites
  W_GF_001: 'Loading your favourites failed, please try again. ',

  // Add/Delete Favourite
  W_ADF_001: 'Adding/deleting a new favourite failed, please try again. ',

  // GetEventsForLocation
  W_GEFL_001:
    'Retrieving the events for the location failed, please try again. ',

  // GetLocationDetails
  W_GLD_001: 'Retrieving the location details failed, please try again. ',

  // GetEventsBasedOnUserLevel
  W_GEBOU_001: 'Loading the events failed, please try again. ',

  // GetLocations
  W_GL_001: 'Loading the locations failed, please try again. ',

  // DeleteEvent
  W_DE_001: 'Something went wrong while deleting the event, please try again. ',

  // GetPostOfEvent
  W_GPOE_001: 'Loading the event-poster failed, please try again. ',

  // GetAccounts
  W_GA_001: 'Loading the accounts failed, please try again. ',

  // SaveEvent
  W_SE_001: 'Saving the event failed, please try again later. ',

  // ActivateAccount
  W_AA_001:
    'No tokens were received after the activation of the account, please try again. ',
  W_AA_002: 'Activation of the account failed, please try again. ',

  // CreateAccount
  W_CA_001:
    'Email could not be confirmed because they was no email received, please try again. ',
  W_CA_002: 'Creation of the account failed, please try again. ',

  // UpdateAccount
  W_UA_001: 'Updating the account failed, please try again later. ',

  // GetExactCsvs
  W_GEC_001: 'Loading the Exact-files failed, please try again later. ',

  // GenerateSalesFees
  W_GSF_001: 'The generation of sales fees failed, please try again. ',

  // GenerateMonthlyFees
  W_GMF_001: 'The generation of the monthly fees failed, please try again.',

  // GetSalesFeesPref
  W_GSFP_001: 'There was no start-date received, please try again. ',
  W_GSFP_002: 'There was no end-date received, please try again. ',
  W_GSFP_003: 'There was no generation date received, please try again. ',
  W_GSFP_004:
    'Loading the Sales and Fees preferences failed, please try again. ',

  // SetSalesFeesPref
  W_SSFP_001:
    'Storing the Sales and Fees preferences failed, please try again. ',

  // Standard Contact Helpdesk
  W_HELPDESK_001:
    'If this problem keeps occurring, please contact the helpdesk from SuperLinda. ',

  // Book
  NOT_CHOSEN: "You haven't chosen anything yet.",

  // shopping cart
  SHOPPINGCART_NOT_EMPTY_DESCRIPTION:
    'There are still products in your shopping cart. If you log out, these products will also be removed from the shopping cart.',
  SHOPPINGCART_SURE_ABOUT_LOGGING_OUT: 'Are you sure you want to log out?',
  SHOPPINGCART_NOT_EMPTY: 'Your shopping cart is not empty',
  SHOPPINGCART: 'Shopping cart',
  ADD_REQUEST: 'Add a request',
  REQUEST: 'Request',
  SHOPPINGCART_EMPTY: 'Your shopping cart is empty',
  CARTITEM_REMOVED: 'Item is removed from shopping cart',
  CARTITEM_NOT_REMOVED: 'Item is not removed from shopping cart, try again',
  FAILED_ADD_CART:
    'Failed adding your product(s) to your shopping cart, please try again',
  FAILED_ADD_SHOPPINGLIST:
    'Failed adding your product(s) to your order list, please try again',
  ADD_CART: 'Your product(s) have been added to your shopping cart',

  TICKETS_RESERVED: 'Your ticket(s) have been reserved',
  TICKETS_FAIL_RESERVED: 'Failed reservering your ticket(s), please try again',
  PARTNER_DOESNT_EXIST: 'This partner group does not exist.',
  BOOKING_FAIL: 'Failed booking your order, please try again.',

  // DeliveryRouteGenerate screen
  'TIME/DATEINFO': 'Time/Date info',
  DELIVERY: 'Delivery',
  PICKUP: 'Pick up',
  TRANSPORT: 'Transport',
  GENERATE_ROUTE: 'Generate route',
  ADD_DELIVERY_PERSON: 'Add delivery person',
  DELIVERY_CONFIG: 'Deliver configurator',
  DELIVERER: 'Deliverer',
  DELIVERYNR: 'Delivery number',
  LOCATION_NOT_FOUND: 'Location not found',
  CAR: 'Car',
  BICYCLE: 'Bicycle',
  WALKING: 'Walking',
  HOUR: 'Hour',
  START_CONFIGURE: 'Start configuring first',

  // Lorenzo added new translations not in Deutsch
  UNCONFIRMED: 'Unconfirmed',
  CONFIRMED: 'Confirmed',
  WAITING_FOR_PAYMENT: 'Waiting for payment',
  ARRIVED: 'Arrived',
  FIRSTNAME: 'Firstname',
  LASTNAME: 'Lastname',
  PLACE_OF_RESIDENCE: 'Place of residence',
  DATE_OF_BIRTH: 'Date of birth',
  ORDERID: 'Order id',

  USER_SUCCESS_UNSUBSCRIBED: 'You have successfully been unsubscribed',
  USER_FAILED_UNSUBSCRIBED:
    'Failed to unsubscribe this user, please try again later',
  USER_PROGRESS_UNSUBSCRIBED: 'Unsubscribing user',
  USER_PROGRESS_ACTIVATION: 'Activating user',
  USER_SUCCESS_ACTIVATED: 'The activation of your account succeeded!',
  USER_SUCCESS_ACTIVATED_LINK: 'Registered your account with the app?',
  USER_SUCCESS_ACTIVATED_DOWN:
    'Are you a web user? We also have a app available. If you want to use the app, please click on the store for your phone and download our app or continue on the web.',
  USER_ACTIVATION_FAILED: 'The activation of your account failed',

  USER_NOT_ACTIVATED_TEXT:
    'Your account has not been activated yet, please click on the activation link in the activation mail that you received to continue.',
  USER_NOT_ACTIVATED_MAIL:
    "If you can't find the mail, or you haven't received the mail yet, please click on the button below to resend the activation mail to: ",
  RESEND_ACTIVATION: 'Resend activation-mail',
  ACTIVATION_MAIL_IS_SEND: 'The mail has been send to: ',
  USER_FORGOT_PASSWORD: 'Your login details will be resend to your mail.',
  USER_FORGOT_PASSWORD_SEND: 'Your login details has been resend to your mail.',
  RESEND_LOGIN_DETAILS: 'Resend login details',
  FORGOT_PASS: 'Forgot password?',
  USER_PASS:
    "Then go back to the app click on 'log in' and log in with your email address and password below:",
  FORGOT_PASSWORD_BACK: 'Back',
  RESET_PASS_TITLE: 'Reset your password',
  RESET_PASS_SUBTITLE:
    'The link to reset your password will be sent to your mailbox',
  RESET_PASS_MAIL_SENT_TITLE:
    'The link to reset your password has been sent to your mailbox',
  CHECK_SPAM_REMINDER:
    "Check your spam folder in case you didn't receive the email",
  OLD_PASS: 'Old password',
  NEW_PASS: 'New password',
  CONFIRM_NEW_PASS: 'Confirm new password',
  PASS_NOT_MATCH: "New password doesn't match the confirm password",
  SAVE_AND_LOGIN: 'Save and login',
  PASS_CHANGED_DESC: 'Your new password has been saved successfully',
  REGISTER_PASS_NOT_MATCH: "Password doesn't match the confirm password",
  PASS_LENGTH_LIMIT: 'The length must be between 8 and 48 characters',
  CONFIRM_PASS: 'Confirm the password',

  EVENT_DESCRIPTION_EC: 'Event description',
  EVENT_DURATION_EC: 'Average duration',
  EVENT_PART_OF_THEMES_EC: 'Part of themes: ',
  EVENT_BUDGET_EC: 'Event budget',
  EVENT_REM_BUDGET_EC: 'Remaining event budget',
  EVENT_PRE_EVENT_Q_EC: 'Pre event question (answer is always yes/no)',
  EVENT_PRE_EVENT_Q_SMALL_EC: 'Pre event question',
  EVENT_MANAGED_EC:
    'Please select this option if the event is managed by a planboard',
  EVENT_TICKET_TYPES_EC:
    'To add tickets to the event, please click on the button below',
  EVENT_BOOKING_POL_EC:
    'To add booking policies for the event, please click on the button below',
  EVENT_SUG_EC:
    'To add suggestions to the event, please click on the button below',
  EVENT_ALTER_EC:
    'To add alternatives to the event, please click on the button below',
  EVENT_SUB_ACT_EC:
    'To add sub-activities to the event, please click on the button below',

  // Partner confirmation
  PAR_CON_LEAD_P1: 'The confirmation of the order: ',
  PAR_CON_LEAD_P2: ' has been received. The new confirmed status is: ',
  PAR_CON_LEAD_P3:
    'There was no confirmation received, please re-click on the link in your mail to try again. ',
  PAR_CON_OR_ST_ACC: 'Accepted',
  PAR_CON_OR_ST_REJ: 'Rejected',
  PAR_CON_OR_ST_FAI: 'Failed',
  PAR_CON_ORDER: 'Order-ID: ',
  PAR_CON_CONFIRMATION: 'Confirmation-ID: ',
  PAR_CON_STATUS: 'Status ',

  // Stock details
  CHANGE_STOCK: 'Changing the stock',
  VALID_CAPACITY: 'Please enter a valid capacity',
  STOCK_PRO_SUC_CHANGED:
    'The stock for the selected product has successfully been changed',
  STOCK_ITEM_SUC_CHANGED:
    'The stock for the selected product-item has successfully been changed',
  CONFIRM_PRODUCT_PART_1: 'Are you sure u want to set the product ',
  CONFIRM_PRODUCT_PART_2: " to 'Out of Stock'? ",
  ENTER_NEW_PRO_STOCK: 'Pleas enter the new stock below for the product: ',
  CONFIRM_ITEM:
    "Please confirm that you want to put the selected product-item to 'Out of Stock' ",
  ENTER_NEW_ITEM_STOCK:
    'Please enter the new stock below for the product-item ',

  // location
  LOCATION_SQUARE_PER_PERSON: 'Please enter the min. square meter per person',
  LOCATION_PUBLIC_TRANSPORT: 'Public transport',
  LOCATION_MARK_LOCATION: 'Mark location',
  LOCATION_BOUNDARIES: 'Boundaries',
  LOCATION_LATITUDE: 'Latitude',
  LOCATION_LONGITUDE: 'Longitude',
  LOCATION_RADIUS: 'Radius',
  LOCATION_USED_BY: 'Used by',
  LOCATION_ENTRY_POINT: 'Entry point',
  LOCATION_ENTRY: 'Entry',
  LOCATION_EXIT: 'Exit',
  'LOCATION_ENTRY/EXIT': 'Entry / exit',
  LOCATIONS_CONTAINS: 'Location contains',
  LOCATION_ARE_YOU_SURE: 'children? Are you sure?',

  // map
  MAP_SELECT_LOCATION: 'Select a location with: Right+Click.',
  MAP_TOUR_CONFIGURATION: 'Configuration for the tour',
  MAP_SELECTED_TOUR_ACTIVITIES: 'Selected tour activities',

  // Policies
  POLICIES_EXPLANATION: 'Some explanation about event policies',
  POLICIES_NEW: 'New policy',

  // Filter
  FILTER_SELECT: 'Select filters',
  FILTER_NO_SELECTED: 'No filters selected',
  FILTER_SELECTED: 'Selected filters',

  // Alternative
  ALTERNATIVE_SELECT: 'Select alternatives',

  // Reviews
  LOAD_MORE: 'Load more',
  REVIEWS: 'Reviews',
  NEWEST_REVIEWS: 'Newest reviews',
  REVIEW: 'Review',
  REVIEW_WRITE: 'Write a review',
  REVIEW_SUCCESS: 'Review placed successfully.',
  REVIEW_FAIL: 'Something went wrong placing your review.',
  REVIEWS_SEE_MORE: 'See more',
  REVIEWS_NO_MESSAGES_YET: 'There are no reviews available yet',
  REVIEWS_TITLE: 'What people think of us',

  // HomepageBanner
  BANNER_SEARCH_EVENT_TITLE: 'Search the event that fit your needs!',
  BANNER_SEARCH_EVENT_SUBTITLE:
    "Press 'enter' to use our filter screen for events..",

  // HomepageThemes
  DISCOVER_THEMES: 'Discover our themes',

  // HomepageApp
  CHOOSE_THE_APP_REASON_1: 'Go on adventure and follow one of our many routes',
  CHOOSE_THE_APP_REASON_2: 'Report incidents to help out yourself and others',
  CHOOSE_THE_APP_REASON_3: 'Manage your bookings on the go',

  // Header
  ALL_LANGUAGES: 'All languages',

  // ProductInfo
  PRODUCT_WEIGHTED_ATTENTION_TEXT:
    'This product is sold on the basis of quantity and unit price. The exact quantity is determined after ordering, so the final price may vary slightly',

  // EventDetails Products
  ATTENTION: 'Attention',
  OVERWRITE_SHOPPING_CART_ITEM:
    "This product is already in your shopp§ing-cart. By clicking 'Add to shopping-cart' the shopping-cart item will be overwritten.",
  ADD_TO_SHOPPING_CART: 'Add to shopping cart',
  PRODUCT_INFO_TEXT:
    'This product is sold on the basic of quantity and unit price. The exact quantity is determined after ordering, so the final price may vary slightly.',
  REQUEST_INFO_TEXT:
    'Your request will be processed, as soon as you complete your order. You will receive a message about the costs at a later time and you can pay for your order.',
  AVAILABLE_CATEGORIES: 'Available categories',

  // HomepageFooter
  IOS_APP: 'iOS app',
  AND_APP: 'Android app',
  MENU: 'Menu',
  HOME: 'Home',
  ABOUT_US: 'About us',
  ABOUT_BUYFRESH: 'About BuyFresh',
  PARTNERS: 'Partners',
  CONTACT: 'Contact',
  NEED_HELP: 'Need help?',
  CONTACT_PAGE: 'Go to the contact page',
  VIEW_FAQ: 'View the FAQ',
  PAGE_SELECT: 'select a page',
  PARTNER: 'Partner',

  // Delivery & pickup
  DELIVERY_PICKUP: 'Delivery & pickup',
  INCLUDED_AREAS: 'We deliver to the following areas: ',
  EXCLUDED_AREAS: 'We do not deliver to the following areas: ',
  NO_DELIVERY_OR_PICKUP: "Couldn't get Delivery and Pick-up events...",
  DELIVERY_STARTS_FROM: 'Minimal order value for delivery is',
  DELIVERY_NO_ENOUGH_PRODUCTS:
    'Add some more products to your order to enable shipping or select a different shipping method (price left)',

  // succes.vue
  BACK_HOME_PAGE: 'Back to Homepage',
  // UserConfirmation
  ALERT_TEXT_CONFIRMED:
    'We received your request, but the order is already confirmed. This window will close automatically.',
  ALERT_TEXT_WAI_FOR_PAY_ACCEPT:
    'We received your acceptance, you will be automatically redirected to the payment page.',
  ALERT_TEXT_WAI_FOR_PAY_REJECT:
    'We received your rejection, your order has been cancelled. This window will close automatically.',
  ALERT_TEXT_CANCELLED:
    'Your order is cancelled, no actions possible on this order. This window will close automatically.',
  ALERT_TEXT_DONE:
    'Your order is already done, no actions possible on this order. This window will close automatically.',
  ALERT_TEXT_PAR_CONF:
    "you've already accepted/rejected this order. The order is waiting for partner confirmation. No actions possible on this order. This window will close automatically",
  ALERT_TEXT_ERROR:
    'Someting went wrong. Please try again. This window will close automatically',

  // About us page
  ABOUTUS: 'About us',
  ABOUTUS_INFO_PART1:
    'Buy Fresh is an online collaboration platform of local growers, butchers, bakers and cheese farmers. Buy Fresh is the ideal combination of online and a physical store.',
  ABOUTUS_INFO_PART2:
    'Buy Fresh makes it easy to choose the quality of the local fresh specialist. You can order products from several specialists at once via one webshop.',
  ABOUTUS_INFO_PART3:
    'With Buy Fresh, the specialists can easily organize the processing of orders, the setting up of pick-up points or the delivery of orders together.',
  ABOUTUS_INFO_PART4:
    "Through smart online collaboration, the specialists benefit from each other's customers and share the costs of pick-up points and delivery, making this more profitable.",
  ABOUTUS_INFO_PART5:
    "The convenience of the online supermarket, with the quality of the local specialist. That's Buy Fresh.",
  ABOUTUS_INFO_PART6: 'Interested? mail to ',

  // Error codes for booking flow
  E_PO_006_SUBSCRIPTION_PRODUCT:
    'Some products in your subscription are not available anymore.',
  E_PO_006_PRODUCT: 'This product is not available anymore.',
  E_PO_006_TICKET:
    'This event has not enough capacity. Try a different date/time or change the number of tickets.',
  E_PO_011:
    'This booking conflicts with earlier planned activities! Are you sure you want to continue?',
  E_PO_023_ADDPRODUCT:
    "Can't add this product to your shopping cart items, because the items are expired. Your shopping cart will be emptied and this product will be added.",
  E_PO_023_CHANGEPRODUCT:
    "Can't change this product, because the items in your shopping cart are expired. Your shopping cart will be emptied and this product with change will be added.",
  E_PO_023_BOOKWITHRESERVATIONS:
    "Can't book the shopping cart items, because they are expired. Your shopping cart will be emptied. You can add new items.",
  E_PO_024_ADDPRODUCT:
    "Can't add this product, because it's not part of your order anymore.",
  E_PO_024_CHANGEPRODUCT:
    "Can't change this product, because it's not part of your order anymore.",
  E_PO_024_ADDSPECIALREQUEST:
    "Can't add this special request, because it's not part of your order anymore.",
  E_DEL_007_DELIVERY_ADD_PRODUCT:
    'Failed to add the product, which is excluded by your selected delivery service. Please make a separate order for this product.',
  E_DEL_007_PICKUP_ADD_PRODUCT:
    'Failed to add the product, which cannot be picked up in your selected pickup location. Please make a separate order for this product.',
  E_SL_001:
    'This product needs partner confirmation and can therefore not be added to your order list.',
  E_USR_077_ADD_TO_LIST:
    'This product can not be added to your order list, because direct debit or buying on account must be enabled.',
  E_DEL_002:
    'Minimum order value is not reached to reserve the products. Please add more products or select a different shipping method.',

  // Account
  SIGN_IN: 'Sign in',
  NOT_A_MEMBER: 'Not a member?',
  BACK_TO: 'Back to',

  // Activities
  HISTORY: 'History',
  NO_UPCOMING_ACTIVITIES: 'You have no upcoming activities..',
  NO_PAST_ACTIVITIES: 'You have no past activities..',
  NOTE: 'Note',
  GET_TICKETS: 'Get tickets',
  CANCEL_ACTIVITY: 'Cancel activity',
  LEAVE_A_REVIEW: 'Leave a review',
  REVIEWED: 'Reviewed',
  PICK_A_RATING: 'Please pick a rating',
  SUBMIT: 'Submit',
  DELETE_ACTIVITY: 'Delete activity',
  SURE_CANCEL_ACTIVITY: 'Are you sure you want to cancel this activity?',

  // Booking
  DELIVERY_SERVICES: 'Delivery services',
  TAKE_AWAY: 'Take-away',
  SPECIAL_REQUEST: 'Special Request',
  ORDER_CONFIRMATION: 'Order confirmation',
  BOOKING_CREDIT:
    'If you have credit with this webshop, it will automatically be deducted from the order',
  BOOKING_COMPLETE: 'Complete',
  BOOKING_OUR_SUGGESTIONS: 'Our suggestions',
  BOOKING_CREATE_ACCOUNT: 'I want to create an account for future bookings',
  AGREE_PRIVACY_STATEMENT_BOOK:
    'By creating an account or order, you agree to our',

  // Event
  ADD_SPECIAL_REQUEST: 'Add special request',
  SEND_SPECIAL_REQUEST: 'Send special request',

  // Yet to be placed correctly
  LOG_IN: 'Login',
  EMAIL_REQUIRED: 'E-mail is required',
  EMAIL_VALID: 'E-mail must be valid',
  EMAIL_NO_MATCH: 'The entered E-mail addresses do not match',
  PASSWORD_REQUIRED: 'Password is required',
  FIRST_NAME_REQUIRED: 'First name is required',
  LAST_NAME_REQUIRED: 'Last name is required',
  PHONE_NR_REQUIRED: 'Phone number is required',
  STREET_REQUIRED: 'Street is required',
  HOUSE_NR_REQUIRED: 'House number is required',
  POSTAL_CODE_REQUIRED: 'Postal code is required',
  LOGIN_GOOGLE: 'Login with google',
  LOGIN_FACEBOOK: 'Login with facebook',
  LOGIN_APPLE: 'Login with apple',
  OR: 'Or',
  NO_SUCCESS_LOGGED_IN: 'Failed to login',
  LOGIN_ERROR:
    'Login failed! Check whether you have entered everything correctly.',
  SUCCESS_LOGGED_IN: 'Succussfully logged in',
  SUCCESS_LOGGED_OUT: 'Successfully logged out',
  LOADING_ACTIVITIES_FAILED:
    'Something went wrong while loading your activities, please try again later',
  BOOK_ORDER_FAILED:
    'Something went wrong while booking your order, please try again later',
  NO_DELIVERY_FOR_POSTAL_CODE:
    'No delivery possible for the selected postal code',
  FAILED_RESERVING_TICKETS: 'Failed reserving your ticket(s), please try again',
  ONE_MOMENT: 'One moment...',
  WAITING_PAYMENT_PROCESS: 'Waiting for the payment to be processed',
  PAYMENT_RECEIVED: 'Payment received',
  PAYMENT_RECEIVED_DESC:
    'Your payment has been received. You can view your planned activities by clicking on the button below',
  PAYMENT_FAILED_DESC:
    'The transaction failed and your payment has not been received. Please check your mail for instructions.',
  PRODUCT_OVERWRITED_ITEM_IN_SHOPPING_CART:
    'Product successfully overwrited your item in your shopping cart',
  ADD_SPECIAL_REQUEST_HERE: 'Add your special request here',
  SPECIAL_REQUEST_SEND: 'The special request has been send to the partner',
  FAILED_ADDING_SPECIAL_REQUEST:
    'Failed adding your special request to your reservation, please try again',
  FAILED_BOOKING_SPECIAL_REQUEST:
    'Failed booking your special request, please try again',
  THE_EVENT: 'The event ',
  THE_PRODUCT: 'The product ',
  THE_CATEGORY: 'The category ',
  ADDED_TO_FAV: ' has been added to your favourites',
  ADDED_TO_FAV_GENERIC: 'Successfully added to your favourites',
  DELETED_FROM_FAV: ' has been deleted from your favourites',
  DELETED_FROM_FAV_GENERIC: 'Successfully removed from your favourites',
  SHOW_VIDEO: 'Show video',
  SHOW_URL: 'Show URL',
  UNIT_PRICE: 'Unit price',
  UPLOAD_AN_IMAGE: 'Upload an image',
  IMAGE_SIZE_NOT_REGULAR: 'Image size is not regular',
  IMAGE_SIZE_NOT_REGULAR_SAVE:
    'Are you sure you want to upload the chosen image ? On the app on mobiles the ratio will be off',
  IMG_UPLOAD_ERR: 'Something went wrong trying to save your image.',
  FLIP_X: 'Flip horizontally',
  FLIP_Y: 'Flip vertically',
  CROP_EXPL:
    'Before adding your photo, you can change your photo here as you wish.',
  UPLOAD_VIDEO: 'Upload a video',
  DELETE_VIDEO: 'Delete the video',
  FILE_SIZE_EXCEED_MAX: 'File size should not be larger than %s MB',
  UPLOAD_FILE_FAILED: 'Failed to upload the file. Please try again later.',
  VIDEO_NOT_SUPPORT: 'Your browser does not support embedded videos',
  FILE_NOT_BIGGER_THAN_10MB: "File can't be bigger than 10Mb",
  FILE_NOT_AVAILABLE: 'File is not available',
  BANNER_NOT_LOADED: 'The banner was not loaded',
  NO_LOCATIONS_LOADED: 'No locations loaded',
  ACCOUNT_SETTINGS: 'Account settings',
  INTERESTS: 'Interests',
  FAVOURITES: 'Favourites',
  NOTIFICATIONS: 'Notifications',
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  HOUSE_NR: 'House number',
  PICK_AN_AVATAR: 'Pick an avatar',
  DIRECT_DEBIT_TITLE: 'More comfort in ordering?',
  DIRECT_DEBIT_DESC_1: 'Are you ordering frequently?',
  DIRECT_DEBIT_DESC_2:
    'Make it yourself easy and pay with direct debitting. You can order quick, without any fuzz. You find, you select and you are done.',
  DIRECT_DEBIT_DESC_3: 'Do you also want to pay with direct debit?',
  DIRECT_DEBIT_DESC_4: 'Start now!',
  DIRECT_DEBIT_DESC_LIST_1: '1. Fill in your details and confirm.',
  DIRECT_DEBIT_DESC_LIST_2: '2. Make a first payment with ideal.',
  DIRECT_DEBIT_DESC_LIST_3:
    '3. Within two working days the direct debit is enabled.',
  I_WANT_TO_USE_DIRECT_DEBIT: 'Yes, i want to use direct debit',
  ACTIVATE_DIRECT_DEBIT: 'Activate direct debit',
  DEACTIVATE_DIRECT_DEBIT: 'Deactivate direct debit',
  DEACTIVATE_DIRECT_DEBIT_MSG:
    'If direct debit is deactivated, you will need more steps to complete your orders. You can still activate direct debit again if you want more convenience in ordering. Do you want to proceed with deactivation?',
  DIRECT_DEBIT_ACTIVATED: 'Direct debit activated',
  DIRECT_DEBIT_NOT_ACTIVATED: 'Direct debit not activated',
  DEACTIVATE_DIRECT_DEBIT_GENERIC_ERROR:
    'Failed to deactivate direct debit. Please try again later.',
  DEACTIVATE_DIRECT_DEBIT_SUBSCRIPTION_ERROR:
    'Failed to deactivate direct debit due to active subscriptions below. Stop following subscriptions first and then try again.',
  ACTIVATE_DIRECT_DEBIT_ERROR:
    'Failed to activate direct debit. Please try again later.',
  DIRECT_DEBIT_PAYMENT_SUCCESS_DESC:
    'Your payment to activate direct debit has been received. Enjoy your ordering with a safer and more convenient experience.',
  DIRECT_DEBIT_PAYMENT_FAILED_DESC:
    'The transaction failed and direct debit is not activated. Please try again later.',
  ACCOUNT_HOLDER_NAME: 'Account holder name',
  SUCCESS_SAVING_SETTINGS: 'Your settings have been saved',
  FAILED_SAVING_SETTINGS: 'Failed while saving your settings, please try again',
  AVATAR_SIZE_MAX_2MB: 'Avatar size should be less than 2 MB',
  FAILED_SAVING_FAVOURITES: 'Failed saving your favourites',
  FAILED_GET_INTERESTS: 'Failed to retrieve your interests, please try again',
  FAILED_SAVING_INTERESTS: 'Failed to save your interests, please try again',
  AGREE_NOTIFICATIONS:
    'By selecting this checkbox, you agree to receive notifications',
  FAILED_GET_NOTIFICATIONS: 'Failed to retrieve your notification settings',
  SUCCESS_SAVE_NOTIFICATIONS: 'Your notification settings have been saved',
  FAILED_SAVE_NOTIFICATIONS:
    'Failed to save your notification settings, please try again',
  STAT_VIEWS: 'Views',
  TRENDING_PRODUCTS: 'Trending products',
  TRENDING_EVENTS: 'Trending activities',
  TRENDING: 'These are our top picks',
  TRENDING_NO_ITEMS: 'No trending items',
  GO_TO_ACCOUNT_SETTINGS: 'Go to settings',

  // Subscriptions
  SUBSCRIPTION_TEXT: 'How would you like to be notified for new (recepten):',
  SUBSCRIPTION_EMAILS: 'Emails',
  SUBSCRIPTION_PUSH: 'Push notifications',
  CANCEL: 'Cancel',

  NO_REVIEWS_AVAILABLE: 'There are no reviews available yet',
  PICKUP_POINT: 'Pick-up point',
  NO_NAME_AVAILABLE: 'No name available',
  NO_ADDRESS_AVAILABLE: 'No address available',
  NO_PHONE_NUMBER_AVAILABLE: 'No phone number available',
  NO_OPENING_HOURS_AVAILABLE: 'No opening hours available',

  VIEW: 'View',
  MAINTENANCE_1:
    "Can't connect to the server. Possible reason is no or a slow internet connection or platform maintenance work.",
  MAINTENANCE_2: "We're trying to reconnect automatically...",
  MAINTENANCE_3: 'In ',
  MAINTENANCE_4: ' seconds',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  ITEMS_ADDED_TO_BASKET: 'Item(s) have been added to your shopping cart',
  ITEMS_ADDED_TO_BASKET_FOR_SHOPPINGLIST: 'Item(s) have been added to',
  ITEMS_CHANGED_TO_BASKET_FOR_SHOPPINGLIST: 'Item(s) have been changed on',
  GO_TO_SHOPPING_CART: 'Go to shopping cart',
  GO_TO_SHOPPING_LIST: 'Go to order list',
  CONTINUE_SHOPPING: 'Continue shopping',
  EMPTY_CART: 'Empty cart',
  ADD_TO_SHOPPING_LIST: 'Add to order list',

  // Chats
  SELECT_PARTNER_TO_CHAT: 'Please select a partner to chat with',
  YOUR_CHAT_WITH: 'Your chat with ',
  NEW_SUBJECT: 'New subject: ',
  TYPE_MESSAGE_HERE: 'Type your message here...',
  MESSAGE_NOT_SEND: 'Message is not send',

  // promotions
  PROMOTIONS_STAY_INFORMED: 'Stay informed',
  PROMOTIONS_INFORMATION:
    'Tap the heart to stay informed of fun promotions like this one.',

  // newsletter
  NEWSLETTER: 'Newsletter',
  NEWSLETTER_TITLE: 'Be the first to know?',
  NEWSLETTER_DESCRIPTION:
    'Stay informed and be the first to receive fun promotions and competitive offers in your mailbox',
  NEWS_LETTER_BUTTON: 'Keep me informed',

  NO_ACTIVITIES: 'No activities available',

  // auction
  AUCTION_EXPLANATION:
    "Bidding works like this: <br> - Go to the auction event <br> - Choose a product to bid on <br> - The amount will expire, so wait until the amount is at your desired amount <br> - Select the amount you want and press 'my' <br> - The product is now yours for the price it ended on",
  SHOPPING_CART_NAME: 'Shopping cart',
  SHOPPING_LIST_NAME: 'Order list name',
  PICK_A_LIST: 'Pick a list',
  NEW_SHOPPING_LIST: '+ new order list',
  TO_CONTINUE_PROVIDE_NAME: 'Please give your order list a name to continue',
  NO_SHOPLIST_YET: 'No order list available, please create one',
  SHOPPINGLISTS: 'Order lists',
  SHOPPINGLISTS_PRODUCTS: 'Order list products',
  SHOPPINGLISTS_DETAILS: 'Order list details',
  NO_PRODUCTS_FOR_SHOPPINGLIST: 'No products yet for order list',
  COPY_TO_SHOPPINGCART: 'Copy to shopping cart',
  ADD_USER_TO_SHOPPINGLIST: 'Add new user',
  ADD_USER: 'Add user',
  ENTER_MAIL: 'Enter mail address',
  CHANGE_SHOPPINGLIST_NAME: 'Change the name of the order list',
  DELETE_SHOPPINGLIST: 'Delete order list',
  SURE_DELETE_SHOPPINGLIST: 'Are you sure you want to delete the order list: ',
  CANCEL_SHOPPINGLIST: 'Cancel the order',
  SURE_CANCEL_SHOPPINGLIST: 'Are you sure you want to cancel the order?',
  DELETE_USER_FROM_MAIL_LIST: 'Delete user from mail list',
  SURE_DELETE_USER_FROM_MAIL_LIST:
    'Are you sure you want to delete the following user from the mail list: ',
  NEW_SHOPPING_LIST_TITLE: 'New order list',
  SAVE_SHOPPING_LIST_ERROR:
    'Failed to save the order list. Please try again later.',

  NEWSLETTER_ALERT_SUCCESS:
    'Thank you for registering, you will now receive fun activities and the best deals in your mail',
  NEWSLETTER_ALERT_USEREXISTED:
    'Unable to succeed the registration, because this mail is already receiving the best deals and fun activities',
  NEWSLETTER_ALERT_ERROR: 'Something went wrong, please try again',
  STATUS: 'Status',
  PAY: 'Pay',
  SEARCH_ORDERS: 'Search orders...',
  DELIVERY_INFORMATION: 'Delivery information',
  DELIVERY_COST: 'Delivery costs',
  GIVE_SHOPPING_LIST_NAME: 'Provide a name for the order list',
  CLEAR_SHOP_LIST: 'Clear order list',
  SURE_CLEAR_SHOP_LIST:
    'Are you sure you want to clear all the products within this order list: ',
  CLEAR: 'Clear',
  LEAVE: 'Leave',
  DUTCHSTAMPS: 'Dutch stamps',
  SAVING_DUTCH_STAMPS: 'Savings Stamps',
  STORE_CREDIT: 'Store credits',
  YOUR_STORE_CREDIT: 'Your store credit for ',
  CONTAINS: 'is: ',
  CURRENT_STAMP_AMOUNT: 'Current stamp amount: ',
  CURRENT_FILLED_STAMP_BOOKS: 'Full sets available: ',
  TOTAL_STAMP_AMOUNT: 'Total stamp amount: ',
  REDEEM_EXPL:
    'If you want to transfer all your filled stamp books to store credit, please click the button below',
  REDEEM: 'Redeem',
  SKIP_DELIVERY: 'Skip next delivery',
  SKIP_DELIVERY_CONFIRM_TITLE: 'Skip next delivery',
  SKIP_DELIVERY_CONFIRM_MESSAGE:
    'Are you sure to skip the next delivery? If so, the system will automatically reschedule the delivery for you based on your repeating option.',
  SKIP_DELIVERY_SUCCESS:
    'The next delivery has been skipped, and a new one is scheduled.',
  SKIP_DELIVERY_ERROR:
    'Failed to skip the next delivery. Please try again later.',
  PAY_SHOPPING_LIST_TITLE: 'Pay order list',
  PAY_SHOPPING_LIST_MESSAGE:
    'Are you sure you want to proceed with the payment?',

  EMPTY_SHOPPINGLIST: 'Clear order list',
  PICK_YOUR_MOMENT: 'Choose pick-up/delivery moment',
  PAY_NOW: 'Order',
  SHOPPING_LIST_DETAILS: 'Order list details',
  ORDER_ONCE: 'You have selected that the order will only be done once',
  ORDER_EVERY_WEEK: 'You have selected that the order will repeat every week',
  ORDER_EVERY_TWO_WEEKS:
    'You have selected that the order will repeat every two weeks',
  ORDER_EVERY_THREE_WEEKS:
    'You have selected that the order will repeat every three weeks',
  ORDER_EVERY_FOUR_WEEKS:
    'You have selected that the order will repeat every month',
  SHOPPING_LIST_DEADLINE: 'Deadline to make changes',
  DELIVERY_SERVICE: 'Delivery service',
  CLEAR_SHOPPING_LIST_MOMENT:
    'I also want to delete my pick-up/delivery moment',
  SUCCESS_SELECTED_SHOPPING_LIST_MOMENT:
    'You have successfully selected a pick-up/delivery moment for this order list',
  SUCCESS_SELECTED_SHOPPING_LIST_MOMENT_EXTRA:
    'The list is automatically ordered if you have permission to order on account or by direct debit. Otherwise, pay for the order manually before the deadline. You will automatically receive an email with a payment link.',
  MOMENT_FOR_SHOPPINGLIST: 'Pick-up/delivery moment for order list',
  PICK_YOUR_DATE_AND_TIME: 'Pick your date and time',
  AUTOMATICALLY_REPEAT_ORDER: 'Do you want to repeat the order automatically?',
  REPEATING: 'Repeating',
  CLEAR_SHOPPING_LIST_AFTER_PAYMENT: 'Clear the order list after payment',
  CONFIRM_PICKUP_DELIVERY_MOMENT: 'Confirm pick-up/delivery moment',
  ONCE: 'Once',
  EVERY_WEEK: 'Every week',
  EVERY_TWO_WEEKS: 'Every two weeks',
  EVERY_THREE_WEEKS: 'Every three weeks',
  EVERY_FOUR_WEEKS: 'Every month',
  EMAIL_NO_MATCH: 'Email does not match',
  PAYMENT_SHOPPINGLIST: 'Payment shoppinglist',
  PAYMENT_SHOPPINGLIST_SURE:
    'Are you sure you want to proceed to payment for the shoppinglist?',
  GO_TO_ACCOUNT: 'Go to account',
  REVIEW_ONLY_WITH_NAME:
    'It is only possible to leave your opinion if you have entered your name in your account details. To leave a review, you need to set your name in your account.',
  CLICK_TO_SET_NAME:
    'Click at the button below to go to your account and fill in your name/surname.',

  // header texts
  HOMEPAGE: 'Homepage',
  CATEGORIES: 'Categories',
  ORDER: 'Order',
  KLANTENSERVICE: 'Service',
  REWARD_CLUB: 'Reward Club',
  CATEGORIES_TITLE: 'Browse our products',

  // customer service
  WHAT_HELP_WITH: 'What can we help you with?',
  MY_ACCOUNT: 'My account',
  MY_ORDERS: 'My orders',
  BUG_REPORT: 'Bug report',
  M_A_Q: 'Most asked questions',
  SHOW_MORE: 'Show more',
  SHOW_LESS: 'Show less',
  REPORT_A_BUG: 'Report bugs to the BuyFresh Helpdesk',
  GO_TO_ACCOUNT: 'Go to your account settings',
  GO_ORDER: 'Go to your orders',
  OTHER_QUESTIONS: 'If you have any other questions feel free to contact us.',
  VOORDELEN_ONLINE: 'Why order online instead of in-store?',
  VOORDELEN_ONLINE_DESC:
    'Ordering online is easy, safe and saves time. You order at home at your convenience in our user-friendly webshop or app and pay contactless and safe online. Your order will be delivered to your home or ready for you at the pick-up point in the store. You avoid crowds and do not have to queue. Moreover, you can be sure that the desired products are available to you. Of course your (payment) data are well protected against malicious parties.\n',
  WHY_ACCOUNT: 'Why is it a good idea to create an account?',
  WHY_ACCOUNT_DESC:
    'With an account you enjoy extra convenience and nice benefits. Easily repeat previous orders, or use our online order list to which you can easily add needed groceries during the week, which you can then order at the touch of a button. It is possible to choose payment by direct debit, so that you do not have to repeat the payment process every time. You also benefit from great savings campaigns, exclusive activities and discounts.',
  QUESTIONS_ORDERS: 'Who can I contact with questions about my order?',
  QUESTIONS_ORDERS_DESC:
    'For questions about or problems with your order, please contact partnernaam. This can be done via <a href="mailto:partnermail">partneremail</a> or <a href="tel:partnernum">partnernumb</a> during opening hours of our store.',
  QUESTIONS_ORDERS_DESC_2:
    'For questions about or problems with your order, please contact partnernaam. This can be done via <a href="mailto:partnermail">partneremail</a> during opening hours of our store.',
  QUESTIONS_PRODUCTS: 'What if I have a wish or question about a product?',
  QUESTIONS_PRODUCTS_DESC:
    'For questions about the range, products or special wishes and requests, please contact partnernaam. This can be done via <a href="mailto:partnermail">partneremail</a> or <a href="tel:partnernum">partnernumb</a> during opening hours of our store.',
  QUESTIONS_PRODUCTS_DESC_2:
    'For questions about the range, products or special wishes and requests, please contact partnernaam. This can be done via <a href="mailto:partnermail">partneremail</a> during opening hours of our store.',
  WORKING_SHOPCREDITS: 'How does online store credit work?',
  WORKING_SHOPCREDITS_DESC:
    'Online store credit is only available to customers with an account. You will be notified if you have new online store credit. Online store credit is automatically deducted from your next online order. You must be logged in to use the online store credit. The store credit is only deducted from the order amount in the last step in the ordering process during payment. There you will see that the amount of your order has been reduced. If you have any questions or problems, please contact the Buy Fresh helpdesk via <a href="mailto:helpdesk@buyfresh.nl">helpdesk@buyfresh.nl</a> or <a href="tel:0297382468">0297 382468</a>.',
  PROBLEMS_WEBSHOP: 'What if I have problems with the webshop or app?',
  PROBLEMS_WEBSHOP_DESC:
    'Are you experiencing a problem with the webshop or app? We find that very annoying, we apologize! We are happy to help you get back on track as soon as possible. If you have any problems or technical questions, please contact the Buy Fresh helpdesk via <a href="mailto:helpdesk@buyfresh.nl">helpdesk@buyfresh.nl</a> or <a href="tel:0297382468">0297 382468</a>.',
  WHAT_BUYFRESH: 'What is Buy Fresh?',
  WHAT_BUYFRESH_DESC:
    'Buy Fresh is an online platform for ordering artisanal products directly from local growers, farmers, butchers, bakers and poulterers. Buy Fresh is the ideal combination of online and a physical store. Buy Fresh makes it easy to choose the quality of the local fresh specialist. By buying through Buy Fresh you support local shops and in many cases opt for more sustainable products from the region. For more information, visit <a href="https://www.buyfresh.nl">www.buyfresh.nl</a>.',
  OPEN: 'Opened',
  MAIL_WITH_US: 'Mail with us',
  CALL_US: 'Call us',
  TECHINCAL_HELP:
    'For help with technical issues please contact the <a href="mailto:helpdesk@buyfresh.nl">Buyfresh</a> helpdesk',
  DIRECTLY_TO: 'Directly to',
  TECH_SUPPORT_TEXT:
    'We’re very sorry you’re experiencing an issue. Let us know what the issue is and we’ll help you as soon as possible. When you report an unknown technical bug, you get € 5 free online shopping credit. ',

  // bug report
  WHEN_OCCURANCE: 'When did the problem occur?',
  DESCRIPTION_PROBLEM: 'Description of the problem ',
  WHAT_PLATFORM:
    'On which platform did the problem occur? Website, mobile website, Android or Apple app?',
  TECHINCAL_SUPPORT: 'Technical support',

  // logout
  ARE_YOU_SURE_LOGOUT: 'Are you sure you want to logout?',

  ONLY_FOR_MEMBERS: 'This product is only available for members',

  // User Dutch stamps
  YOUR_DUTCH_STAMPS: 'Your dutch stamps',
  CREATE_ACCOUNT_FOR_STAMPS:
    'Create an account to start saving for dutch stamps and many other benefits.',
  YOUR_FAVOURITES: 'Your favourites!',
  YOU_HAVE: 'You have',
  FULL_CARDS: 'full cards',
  STAMPS_YOUR_PARTNER_STAMPS: 'Your (partner) stamps',
  OPEN_STAMPS: 'Open my stamps',

  // rental changes
  RENTAL_DIALOG_TITLE: 'Add more items?',
  RENTAL_DIALOG_DESC:
    'Do you want to add more items of this category <b>%s</b> to your order?',

  // Search
  SEARCH_SENTENCE: 'What are you looking for?',

  // open url
  GO_TO: 'Go to',

  RESULTS: 'results',
  NO_STARTDATES:
    'There are sadly no dates on wich these products are available',

  // booking details product
  ALERT_NO_DATES:
    'There are currently no dates on wich your order can be delivered or picked up',

  // blog posts
  BLOG_POSTS: 'Discover',
  BLOGS: 'Recent articles',
  BLOGS_TITLE: 'Have a look at our blogs',

  COPY_TO_CLIPBOARD_SUCCEEDED: 'Successfully copied to clipboard',
  COPY_TO_CLIPBOARD_FAILED: 'Failed to copy to clipboard',
  AGENDA: 'Agenda',
  AGENDA_NO_EVENTS: 'No upcoming events',

  // app promotion
  DOWNLOAD_APP: 'Discover the comfort of our app',
  APP_TEXT:
    'Order easily, safely and quickly with the PARTNERNAAM app. Download now for Android or Apple.',

  // delete account
  ERROR_DELETE_USER:
    'There has been an error deleting the user please try again later',
  SUCCESS_DELETE_ACC: 'Succesfully deleted account',
  DELETE_ACCOUNT: 'Delete account',
  DELETE_ACCOUNT_ARE_YOU_SURE:
    'If you delete your account you will not be able to see any of your orders. Are you sure you want to delete your account? This action cannot be reversed.',

  DAYS: 'days',
  CHARACTERISTICS: 'Characteristics',

  DELIVERY_ADDRESS: 'Delivery address',
  NO_CONFIDENCE_ADDRESS:
    "We couldn't find your address with the zip code and house number you provided, please enter it yourself",
  ENTER_EMAIL_TEXT:
    'Enter your email address to log in, create an account or stay informed about your order',

  // order overview
  ORDER_OV_PRICE: 'Price',
  CONTACT_DETAILS: 'Contact details',

  CONTINUE_AS_GUEST: 'Continue as guest',
  DELIVERY_DETAILS: 'Delivery details',
  DELIVERY_DATE: 'Delivery date and time',
  RESERVE_ORDER: 'Reserve order',
  ENTER_EMAIL: 'Enter your email',
  PHONE_NO_RECOGNITION: 'Incorrect phone number',
  PHONE_NO_RECOGNITION_DESC:
    "We don't recognize this phone number format are you sure it's correct?",
  PHONE_WHY:
    'We ask for your phonenumber so that if something goes wrong with your order we can inform you by phone',
  RETURNING_CUSTOMER: 'Returning customer',
  NEW_CUSTOMER: 'New customer',
  CREATE_ACCOUNT: 'Create an account',
  RENTAL_DETAILS: 'Rental details',
  CHECKOUT: 'Checkout',
  ENTER_YOUR_EMAIL: 'Enter your email',
  EMAIL_WHY:
    'Enter your email to login, create an account or continue as a guest',
  LOGIN_INFO:
    'We have found an account with the given email, do you want to log in?',
  WHY_LOGIN: 'By logging in you can use your user credit and more',
  FOUND_AN_ACCOUNT:
    'We have found an account with your entered email address. Do you want to log in?',
  BENEFITS_REGISTERING:
    'When you register an account, you get access to these benefits and much more!',
  LOGIN_OR_CONTINUE: 'Login or continue as guest',
  CREATE_ACCOUNT_OR_CONTINUE: 'Create an account or continue as guest',
  SUCCESS_REGISTER:
    'You have successfully registered, you have received a confirmation email, please confirm your account.',
  ORDER_ACCOUNT_NOT_ACTIVATED:
    'Account created but not yet activated. Go to your mailbox to activate your account before you can log in and continue.',

  // Subscription
  SUBSCRIBE: 'Subscribe',
  SUBSCRIPTION: 'Subscription',
  CREATE_SUBSCRIPTION: 'Create subscription',
  TAKE_SUBSCRIPTION: 'Take subscription',
  TAKE_SUBSCRIPTION_HTML: 'Take flex<br>subscription',
  ITEMS_NOT_SELECTED: 'Items not selected',
  ITEMS_SELECTED: 'Items selected',
  ADD_ALL: 'Add all',
  REMOVE_ALL: 'Remove all',
  REMOVE: 'Remove',
  CANCEL_ORDER: 'Cancel',
  ADD_SUBSCRIPTION_PRODUCTS_TITLE: 'Choose from the list',
  NO_START_DATES: 'Start dates are not available for your selection',
  NO_START_TIMES: 'Start times are not available for your selection',
  SUBSCRIPTION_REPETITION_TITLE:
    'In what frequency do you want to repeat your subscription?',
  SUBSCRIPTION_REPETITION_FREQUENCY:
    'Repetition frequency of your subscription',
  SUBSCRIPTION_OVERVIEW: 'Subscription overview',
  SUBSCRIPTION_NAME: 'Subscription name',
  SUBSCRIPTION_NAME_TOOLTIP:
    'You can type your preferred subscription name to replace the default one',
  SUBSCRIPTION_PRODUCTS: 'Subscription products',
  PICKUP_DATE_TIME: 'Time',
  CREATE_SUBSCRIPTION_DESC_DIRECT_DEBIT_ON:
    'You have activated direct debit. Your payment will be handled through direct debit automatically.',
  CREATE_SUBSCRIPTION_DESC_DIRECT_DEBIT_OFF:
    'Direct debit is required to create a subscription. By saving your subscription, you pay <b>1 cent</b> to activate direct debit first. Your subscription will be created when the payment is received successfully.',
  CREATE_SUBSCRIPTION_ACTIVATE_DIRECT_DEBIT_TITLE:
    'Activate direct debit to complete the subscription',
  CREATE_SUBSCRIPTION_ACTIVATE_DIRECT_DEBIT_DESC:
    'You will be redirected to the payment page to pay <b>1 cent</b>, which will be added to your credits, to activate direct debit. The purpose of the payment is to provide us with your bank account information for automatic deduction for your subscription. Your subscription will be created when the payment is received successfully.',
  CREATE_SUBSCRIPTION_SUCCESS_TITLE: 'Subscription created',
  CREATE_SUBSCRIPTION_SUCCESS: 'Successfully created the subscription.',
  CREATE_SUBSCRIPTION_ERROR:
    'Failed to create subscription. Please try again later.',
  SUBSCRIPTION_PAYMENT_SUCCESS_MSG:
    'Payment is received to activate direct debit, and your subscription has been successfully created. You can view the subscription in your order lists page.',
  SUBSCRIPTION_PAYMENT_ERROR_MSG:
    'The transaction failed. Direct debit is not activated and your subscription is not created. Try to activate direct debit first in Account Settings page and then create your subscription again. Please contact us if problem persists.',
  CREATE_SUBSCRIPTION_EXPLAN:
    'With the following steps, you can create a new subscription that provides you with periodicly delivery of your desired products.',
  SUBSCRIPTION_TO_DELIVERY_EXPLAN:
    'In the next step you will be able to select the delivery or pickup method and the date/time on which this repetition will start.',
  SUBSCRIPTION_STEP1: 'Step 1: Choose your products',
  SUBSCRIPTION_STEP2: 'Step 2: Subscription type',
  SUBSCRIPTION_STEP3: 'Step 3: Delivery or pickup options',
  SUBSCRIPTION_STEP4: 'Step 4: Summary',
  INVALID_POSTAL_CODE: 'Invalid postal code',
  MIN_SUBSCRIPTION_VALUE:
    'The minimum total value of your selected products to create a subscription is',
  MIN_SUBSCRIPTION_VALUE_ALERT:
    'You need to add more products to the list. The minimum total value of your selected products is',
  SHOPPING_LISTS_AND_SUBSCRIPTIONS: 'Subscriptions and order lists',
  GO_TO_SUBSCRIPTION: 'Go to subscription',
  SUBSCRIPTION_LOGIN_ALERT:
    'Log in or create an account before you can create a subscription',
  SUBSCRIPTION_BENEFITS_TITLE: 'Subscription characteristics',
  ADD_PRODUCT: 'Add product',
  REMOVE_ALL_PRODUCTS: 'Remove all products',
  DELETE_SUBSCRIPTION_TITLE: 'Delete subscription',
  DELETE_SUBSCRIPTION_DESC:
    'Are you sure you want to delete this subscription?',
  LOGIN_REQUIRED: 'Login required',
  SUBSCRIPTION_INTRODUCTION_TITLE: 'Subscription service',
  SUBSCRIPTION_INTRODUCTION_DESC:
    'Do you sometimes forget to order in time or do you just not want to make a new order list every time? We offer the possibility to compile a list of groceries that you can have periodically delivered. You can have it delivered or pick it up yourself at one of the locations. Just before your list is packed, you will be given the option to adjust the list. If you do nothing, the order will be placed automatically. You can also skip it when you are on vacation.<br><br>The nice thing is that you can share this list with your roommates, so that everyone you invite places groceries on the list.<br><br>All advantages at a glance:',
  LIMITED_PRODUCT_LEFT: 'Only %d items left for your selection',
  SUBSCRIPTION_REPEATING_PRODUCTS: 'Repeating products',
  SUBSCRIPTION_ONETIME_PRODUCTS: 'One time products',
  SUBSCRIPTION_QUANTITY: 'Subscription quantity',
  ADD_TO_SUBSCRIPTION: 'Add to subscription',
  REMOVE_ITEM_ERROR: 'Failed to remove the item. Please try again later.',
  UPCOMING_ORDER: 'Upcoming order',
  UPDATE_SUBSCRIPTION: 'Save as default',
  UPDATE_SUBSCRIPTION_DIALOG_MSG:
    'Do you want to update your list with the upcoming order?',
  UPDATE_SUBSCRIPTION_SUCCESS: 'Order list has been successfully updated',
  UPDATE_SUBSCRIPTION_ERROR:
    'Failed to update your list. Please try again later.',
  RESET_SUBSCRIPTION: 'Recover default list',
  RESET_SUBSCRIPTION_DIALOG_MSG:
    'Do you want to recover your order list to the default one?',
  RESET_SUBSCRIPTION_SUCCESS: 'Order list has been successfully recovered',
  RESET_SUBSCRIPTION_ERROR:
    'Failed to recover your order list. Please try again later.',
  ITEM_CHANGE_SAVED: 'Item change has been saved',
  ITEM_REMOVED: 'Item has been removed',

  INTERNATIONAL_DELIVERY_DATE_ALERT:
    'This is your preferred time slot for international delivery, which may differ from the actual delivery time. Please check your email to get the delivery updates from the courier company.',

  COOKIE_TEXT:
    'This website uses cookies to ensure you get the best experience on our website.',

  PRODUCT_PERSONAL_DISCOUNT_TITLE: 'Your personal discount',
  PRODUCT_PERSONAL_DISCOUNT_DESC:
    'Add this product to your shopping cart as soon as possible to get a personal discount',

  PROF_USER_CHECKBOX_LABEL: 'I am a business customer',
  KVK_NUMBER: 'KvK number',
  VAT_NUMBER: 'VAT number',
  VAT: 'VAT',
  TOTAL_PRICE_EXCL_VAT: 'Total price excl. VAT',

  SUBSCRIPTION_BUY_BY_ACCOUNT_REMINDER_MSG:
    'There are two paying options for buying with a subscription list: Buy on Account or Direct Debit. The first option is not available for you on this account. If you wish to use Buying on Account, please contact your supplier. Otherwise continue and you will be asked to enable direct debit later.',

  DELIVERY_OPTIONS: 'Delivery options',
  SERVER_MAINTENANCE_TITLE: 'Server maintenance',
  SERVER_MAINTENANCE_MESSAGE:
    'Our server is temporarily unavailable due to maintenance. Please come back later to try again.',
  POOR_BANDWIDTH_TITLE: 'Slow internet connection',
  POOR_BANDWIDTH_MESSAGE: 'Please check your internet settings.',
  MAKE_CHOICE_FOR_DELIVERY_PICKUP: 'Make a choice',

  QUIZ_INTRO_TEXT:
    "Answer the questions below and press the 'Send' button when you are done.",
  QUIZ_SEND_SUCCESS_TEXT: 'Your answers has been sent successfully.',
  QUIZ_SEND_FAILED_TEXT: 'Failed to send the answers. Please try again later.',
  QUIZ_MUST_CHOOSE_MULTI: 'You must choose one of the options.',
  QUIZ_MUST_FILL_IN: 'You must fill in an answer.',
  QUIZ_MUST_CHOOSE_PHOTO: 'You must select a photo.',
  QUIZ_MUST_CHOOSE_VIDEO: 'You must select a video.',
  QUIZ_MUST_GIVE_NAME: 'We need your first name for communication.',
  QUIZ_TEXT_LABEL: 'Fill in your answer here.',
  QUIZ_NUMBER_LABEL: 'Enter a number here.',
  QUIZ_EMAIL_DESC:
    'We need your email address and first name to inform you about the result and for communications.',
  QUIZ_QUESTION_NOT_ANSW:
    'Can not send your answers. Not all questions are filled in.',

  PRODUCT_OPTIONS_TITLE: 'Options',
  PRODUCT_OPTIONS_DESCR1: 'Select a minimum of ',
  PRODUCT_OPTIONS_DESCR2: ' options and a maximum of ',
  PRODUCT_OPTIONS_DESCR3: ' option(s) too few chosen',
  PRODUCT_OPTIONS_DESCR4: ' options(s) too much chosen',
  PRODUCT_OPTIONS_DESCR5: 'Select ',
  PRODUCT_OPTIONS_DESCR6: ' option(s)',
  PRODUCT_OPTIONS_ERROR:
    'The number of product options selected is not correct.',

  DEF_CHANGE_INVALID_QTY_TITLE: 'Quantity change required',
  DEF_CHANGE_NO_CAPACITY_MSG:
    'This item is out of stock, please choose another one.',
  LEAVE_SHARED_LIST_MSG:
    'You are going to leave current list. After left, you will no longer see this list anymore. Are you sure to leave?',
  DEF_CHANGE_QTY_LESS_THAN_CAPACITY_MSG:
    'There are only %d items left. Do you want to decrease the quantity to this value?',

  SHOPPING_CART_LOWERCASE: 'shopping cart',
  SHOPPING_LIST_LOWERCASE: 'order list',
  E_PCAP_001_ADD_PROD:
    'Failed to add the product to your %s, because the quantity exceeds the maximum. Reduce the number and try again.',
  E_PCAP_001_CHANGE_PROD:
    'Failed to change the product in your %s, because the quantity exceeds the maximum. Reduce the number and try again.',
  E_PCAP_002_ADD_PROD:
    'Failed to add the product to your %s, because the quantity is less than the minimum. Increase the number and try again.',
  E_PCAP_002_CHANGE_PROD:
    'Failed to change the product in your %s, because the quantity is less than the minimum. Increase the number and try again.',

  LEAVE_SHARED_LIST_TITLE: 'Leave the list',

  PAYMENT_METHOD_AUTOMATIC: 'Pay online',
  PAYMENT_METHOD_AUTOMATIC_INFO:
    'Pay for the order with iDEAL/Credit card, user credits, direct debit or buying on account, depending on your account settings.',
  PAYMENT_METHOD_ON_DELIVERY: 'On delivery',
  PAYMENT_METHOD_ON_DELIVERY_INFO:
    'Pay for the order upon delivery or collection, depending on the shipping method.',
  PAYMENT_METHOD_IDEAL_INFO_DIRECT:
    'Pay the order with iDeal. You will be redirected to the Mollie internet payment page.',
  PAYMENT_METHOD_IDEAL_INFO_DELAYED:
    'Pay the order with iDeal. You will receive an email with a payment link.',
  PAYMENT_METHOD_DIRECT_DEBIT_INFO:
    'Pay the order with direct debit. The amount is automatically debited from your account.',
  PAYMENT_METHOD_AT_EVENT_INFO: 'Pay for the order upon pick up/delivery.',
  PAYMENT_METHOD_CREDIT_CARD_INFO_DIRECT:
    'Pay the order with your credit card. You will be redirected to the Mollie internet payment page.',
  PAYMENT_METHOD_CREDIT_CARD_INFO_DELAYED:
    'Pay the order with your credit card. You will receive an email with a payment link.',
  PAYMENT_METHOD_ON_ACCOUNT_INFO:
    'Pay the order on account. You will be sent an invoice.',
  SELECT_PAYMENT_METHOD: 'Choose payment method',
  SELECTED_PAYMENT_METHOD: 'Selected payment method',
  SELECTED_PAYMENT_METHOD_INFO_LIST:
    "If you want to change the payment method, press the 'Cancel' button to stop the automatic repeating order. You can then choose the payment method again with the 'Choose Pick-Up/Delivery moment' button.",
  SELECTED_PAYMENT_METHOD_INFO_SUBSC:
    "If you want to change the payment method, press the 'Delete' button to delete the subscription. You can create the subscription again and choose the payment method.",
  SELECT_PAYMENT_METHOD_NO_SELECT_ERROR:
    'Payment method is required. Please choose one from the list.',
  HOSTNET_ISSUE_ALERT_TITLE: 'Email issue',
  HOSTNET_ISSUE_ALERT:
    'Unfortunately, our email provider Hostnet is currently having problems processing emails. As a result, emails confirming an order may not arrive immediately. They are working hard on a solution. As soon as everything is operational again, we will try to ship it. Sorry for the inconvenience.\nTeam Buy Fresh',
  MINIMUM_ORDER_VALUE_TEMP: 'Minimum order value %s',
  PICKUP_MINIMUM_ORDER_VALUE_ALERT:
    'Minimum order value of %s not reached for selected pickup option.',
  PICKUP_FEE_INFO: 'Pickup fee: %s',
  PICKUP_FEE: 'Pickup fee',
  PICKUP_NOT_POSSIBLE: 'Pickup is not possible for your selection.',
  PICKUP_FREE_ORDER_VALUE: 'Free for order over %s',
  GET_PAYMENT_METHODS_ERROR:
    'Failed to get payment methods. Please try again later.',
  PREVIOUS_BUTTON_PROMOTION: 'Previous promotion',
  NEXT_BUTTON_PROMOTION: 'Next promotion',
  PREVIOUS_BUTTON_BLOG: 'Previous blog',
  NEXT_BUTTON_BLOG: 'Next blog',
  TERMS_AND_CONDITIONS: 'Terms and conditions',
  POWERED_BY: 'Powered by',
};

export { EN as default };
